/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Buffer } from 'buffer';

import {
  Attribute,
  Dependency,
  Measurement,
  MeasurementContainer,
  SelectedImage,
  FilledAccessory,
} from '../../../model/attribute';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { v4 as uuidv4 } from 'uuid'; // Import UUID generator
import {
  AccessoriesData,
  Accessory,
  Option,
} from '../../../model/accessory-order-payload';
import e from 'express';
declare const Snap: any;
@Component({
  selector: 'app-order-flow-measure',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './order-flow-measure.component.html',
  styleUrls: ['./order-flow-measure.component.css'],
})
export class OrderFlowMeasureComponent implements OnInit {
  measurements: MeasurementContainer[] = [];
  accessories: FilledAccessory[] = [];
  public accessoriesData: AccessoriesData = { accessories: [] };

  selectedMeasure: { [measurementId: number]: string } = {};
  measurementValues: { [measureId: number]: number } = {};
  selectedValues: { [attributeGuid: string]: any } = {}; // Use GUID as key
  errors: { [guid: string]: string } = {};
  private processed: { [measurementId: number]: boolean } = {};
  selectedImages: SelectedImage[] = [];
  showInvalidPositionMessage: { [key: string]: boolean } = {};
  attributeOptions: any[] = [];
  fileUrl: string = '';
  videoUrl: string = '';
  text: string = '';
  attributeModified: { [key: string]: boolean } = {};

  // Store sanitized SVG content
  svgContent: { [key: string]: SafeHtml } = {};

  @Input() productName = '';
  @Output() measurementsCompleted = new EventEmitter<MeasurementContainer[]>();
  @Output() accessoriesCompleted = new EventEmitter<FilledAccessory[]>();

  public filledMeasurements: MeasurementContainer[] = [];
  public filledAccessories: FilledAccessory[] = [];

  @ViewChild('svgElement', { static: false })
  svgElement!: ElementRef<SVGElement>;

  @ViewChild('svgContainer', { static: true }) svgContainer!: ElementRef;

  snap: any;
  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.accessories.forEach((accessory) => {
      accessory.accessory.attributes.forEach((attribute) => {
        if (attribute.componentType === 'Select') {
          this.getSvgContent(attribute);
        }
      });
    });

    this.ensureAttributeGuids(this.accessories);

    if (this.accessories && this.accessories.length > 0) {
      console.log('=== [ngOnInit] Accessories Initial State ===');
      let totalAttributes = 0;
      let attributesWithGuid = 0;
      let attributesWithoutGuid = 0;

      this.accessories.forEach((acc, accIdx) => {
        acc.accessory.attributes.forEach((attr) => {
          totalAttributes++;
          const hasGuid = attr.guid && attr.guid.trim() !== '';
          if (hasGuid) {
            attributesWithGuid++;
          } else {
            attributesWithoutGuid++;
            console.warn(
              `⚠️ Attribute "${attr.name}" (ID: ${attr.attributeId}) missing GUID`,
            );
          }
        });
      });

      console.log(
        `Total: ${totalAttributes}, With GUID: ${attributesWithGuid}, Without: ${attributesWithoutGuid}`,
      );
    }

    this.setGuid();

    // Initialize measurements
    this.measurements = this.measurements.map((measurementContainer) => {
      return {
        ...measurementContainer,
        measures: measurementContainer.measures.map((measure) => ({
          ...measure,
          value: measure.selectedValue,
        })),
      };
    });

    this.measurements.forEach((measurementContainer) => {
      measurementContainer.measures.forEach((measure) => {
        if (
          measure.selectedValue !== undefined &&
          measure.selectedValue !== null
        ) {
          this.measurementValues[measure.id] = parseFloat(
            measure.selectedValue.toString(),
          );
        }
      });
    });

    this.setGuid();
  }

  getDownloadGuidlinesUrl() {
    if (this.measurements && this.measurements.length > 0) {
      this.fileUrl = this.measurements[0]?.fileUrl ?? '';
      this.videoUrl = this.measurements[0]?.videoUrl ?? '';
      this.text = this.measurements[0]?.text ?? '';

      return this.fileUrl;
    }

    const formattedProductName = this.productName.split(' ').join('');
    return `https://sigmtmweblobuat.blob.core.windows.net/guides/${formattedProductName}.pdf`;
  }

  /**
   * Assign a unique GUID to each attribute if it doesn't already have one.
   * This ensures consistency between insert and edit modes.
   */
  setGuid(): void {
    let newGuidsGenerated = 0;
    let existingGuidsPreserved = 0;

    this.accessories.forEach((accessory) => {
      accessory.accessory.attributes.forEach((attribute) => {
        if (!attribute.guid || attribute.guid.trim() === '') {
          attribute.guid = uuidv4();
          newGuidsGenerated++;
          console.log(
            `[setGuid] Generated new GUID for "${attribute.name}": ${attribute.guid}`,
          );
        } else {
          existingGuidsPreserved++;
          console.log(
            `[setGuid] Preserved existing GUID for "${attribute.name}": ${attribute.guid}`,
          );
        }
      });
    });

    console.log(
      `[setGuid] Summary: ${newGuidsGenerated} new, ${existingGuidsPreserved} preserved`,
    );
  }

  /**
   * Emit completed data to the parent component.
   */
  public emitCompletedData(): void {
    this.completeMeasurements();
  }

  /**
   * Collects the filled measurements and accessories and emits them to the parent component.
   */
  public completeMeasurements(): void {
    if (this.isValid()) {
      this.collectFilledMeasurements();
      this.collectFilledAccessories();
    } else {
      this.markAllFieldsAsTouched();
    }
  }

  /**
   * Collects filled measurements into MeasurementContainer[].
   */
  public collectFilledMeasurements(): void {
    this.filledMeasurements = this.measurements.map((measurementContainer) => {
      return {
        ...measurementContainer,
        measures: measurementContainer.measures.map((measure) => ({
          ...measure,
          value: measure.selectedValue, // Ensure value is updated from user input
        })),
      };
    });

    // Emit the filled measurements to the parent component
    this.measurementsCompleted.emit(this.filledMeasurements);

    this.fileUrl = this.filledMeasurements[0]?.fileUrl ?? '';
    this.videoUrl = this.filledMeasurements[0]?.videoUrl ?? '';
    this.text = this.filledMeasurements[0]?.text ?? '';
  }

  private generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
  }

  private ensureAttributeGuids(accessories: any[]): void {
    accessories?.forEach((accessory) => {
      accessory.accessory?.attributes?.forEach((attribute: any) => {
        if (!attribute.guid) {
          attribute.guid = this.generateGuid();
        }
      });
    });
  }

  /**
   * Collects filled accessories into FilledAccessory[].
   */
  public collectFilledAccessories(): void {
    this.filledAccessories = this.accessories.map((accessory) => {
      const selectedAttributes: Attribute[] = accessory.accessory.attributes
        .filter((attr) => {
          if (!attr.guid || attr.guid.trim() === '') {
            console.error(`❌ Attribute "${attr.name}" has no GUID!`);
            // Gerar GUID emergencial
            attr.guid = uuidv4();
            console.warn(`⚠️ Emergency GUID generated: ${attr.guid}`);
          }

          const valueId = this.selectedValues[attr.guid];
          return !attr.isHidden && valueId !== undefined && valueId !== null;
        })
        .map((attr) => {
          const valueId = this.selectedValues[attr.guid];
          const selectedValue = attr.values.find((val) => val.id === valueId);
          return {
            ...attr,
            value: selectedValue ? selectedValue.value.toString() : '',
          };
        });

      const selectedImage =
        this.selectedImages.find((img) =>
          accessory.accessory.attributes.some(
            (attr) => attr.guid === img.guid && img.imageUrl != '',
          ),
        ) || null;

      return {
        accessory: accessory.accessory, // Use the inner Accessory object
        selectedAttributes: selectedAttributes,
        selectedImage: selectedImage,
      } as FilledAccessory;
    });

    // Emit the filled accessories to the parent component
    this.accessoriesCompleted.emit(this.filledAccessories);
  }

  getSvgContent(attribute: Attribute): void {
    const image = attribute.values.find(
      (value) => value.id === this.selectedValues[attribute.guid],
    );

    var pathString = '';

    if (
      image?.imageIdentity?.toUpperCase() ==
      '4995F0B8-9B29-4FDF-8A5B-E664356D7C62'
    ) {
      pathString =
        'M 9.997 62.884 L 91.354 62.497 C 93.578 62.497 85.364 126.808 82.443 126.808 C 81.165 128.086 73.547 160.498 74.307 159.738 L 73.145 177.171 L 74.307 194.992 L 79.731 222.499 L 83.218 255.429 L 70.046 330.2 C 69.156 329.31 66.941 360.025 68.109 361.193 L 71.595 391.411 L 87.479 408.457 L 106.075 416.206 L 109.175 421.629 L 106.85 426.666 L 101.814 427.828 L 94.453 427.441 L 88.254 429.378 L 77.019 425.891 L 61.523 418.53 L 49.513 417.368 L 43.702 410.007 L 44.476 399.934 L 44.476 387.537 L 46.414 372.815 L 45.639 360.031 L 41.765 330.975 L 32.467 255.429 L 32.854 238.383 L 35.179 221.337 L 29.367 206.227 L 26.655 195.767 L 25.881 156.639 L 21.232 126.033 L 9.997 62.884 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'A63AF03D-EBBA-4EEE-8287-E845F5A79B04'
    ) {
      pathString =
        'M 58.0359992980957 62.49700164794922 L 139.77999877929688 62.11000061035156 L 129.32000732421875 124.48300170898438 L 123.89600372314453 160.51300048828125 L 123.12200164794922 195.3800048828125 L 114.98600006103516 220.94900512695312 L 118.4729995727539 254.6540069580078 L 108.4000015258789 330.9750061035156 L 104.13800048828125 361.1929931640625 L 103.7509994506836 375.1400146484375 L 106.07499694824219 386.375 L 105.68800354003906 399.15899658203125 L 107.625 409.23199462890625 L 102.97599792480469 416.9800109863281 L 92.51599884033203 418.14300537109375 L 84.37999725341797 420.85400390625 L 70.82099914550781 428.2149963378906 L 60.74800109863281 428.6029968261719 L 56.486000061035156 427.0530090332031 L 51.45000076293945 427.4410095214844 L 47.57600021362305 427.8280029296875 L 42.152000427246094 425.50299072265625 L 40.9900016784668 421.24200439453125 L 44.0890007019043 416.5929870605469 L 57.26100158691406 411.16900634765625 L 68.88400268554688 402.64599609375 L 77.40699768066406 391.7980041503906 L 80.11900329589844 375.1400146484375 L 82.05599975585938 360.80499267578125 L 80.11900329589844 330.20001220703125 L 69.65799713134766 277.5119934082031 L 66.94599914550781 255.04200744628906 L 70.82099914550781 221.33700561523438 L 75.08200073242188 194.99200439453125 L 77.01899719238281 174.8470001220703 L 75.08200073242188 155.86399841308594 L 67.72100067138672 126.41999816894531 L 62.29800033569336 98.5270004272461 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'CF7A510C-192D-4A59-B5F9-2BFF5B3C61A6'
    ) {
      pathString =
        'M 18.901 127.256 L 23.075 159.893 L 23.834 195.567 L 31.425 221.753 L 35.979 236.933 L 35.22 255.529 L 32.943 282.474 L 38.256 331.051 L 39.774 359.894 L 41.671 371.658 L 34.84 387.977 L 36.358 404.296 L 34.461 416.44 L 35.22 421.753 L 42.43 426.307 L 53.815 426.307 L 62.924 418.717 L 86.074 412.266 L 89.489 405.055 L 85.694 401.26 L 78.484 397.844 L 72.032 394.429 L 64.062 392.152 L 62.165 375.833 L 63.303 360.653 L 68.237 330.672 L 79.622 271.469 L 80.381 256.288 L 76.586 222.512 L 75.447 211.506 L 75.447 195.188 L 74.688 184.941 L 77.345 174.315 L 78.863 164.827 L 83.797 127.256 L 91.387 62.36 L 6.756 62.36 L 18.901 127.256 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'BD0799B0-DCFF-4480-A735-50470BAA2069'
    ) {
      pathString =
        'M 65.79 127.826 L 71.851 169.449 L 74.68 186.421 L 74.276 195.311 L 72.66 221.174 L 70.235 236.53 L 69.427 255.523 L 71.447 280.578 L 81.954 331.091 L 86.399 360.59 L 86.399 378.775 L 83.57 392.11 L 76.296 395.343 L 69.023 398.172 L 61.749 400.597 L 60.536 406.254 L 63.769 411.507 L 73.064 414.74 L 83.975 417.569 L 90.844 422.822 L 98.926 426.055 L 107.817 426.863 L 113.878 422.014 L 113.878 412.316 L 113.07 401.809 L 113.878 387.665 L 108.221 371.501 L 108.221 359.782 L 110.645 331.495 L 116.707 287.851 L 114.687 254.715 L 114.282 236.126 L 117.919 221.982 L 125.193 196.12 L 126.406 156.113 L 130.851 126.614 L 142.57 62.361 L 58.516 62.361 L 65.79 127.826 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'DCF3DF99-92F3-4019-8023-414699F38977'
    ) {
      pathString =
        'M 5.3480000495910645 54.361000061035156 L 77.40699768066406 54.361000061035156 L 84.37999725341797 92.3280029296875 L 84.76799774169922 136.8800048828125 L 84.37999725341797 150.44000244140625 L 79.73100280761719 196.15499877929688 L 80.89299774169922 222.49899291992188 L 79.34400177001953 241.8699951171875 L 80.89299774169922 257.3659973144531 L 89.02899932861328 332.52398681640625 L 95.22799682617188 363.1300048828125 L 105.3010025024414 392.96099853515625 L 114.5979995727539 405.7449951171875 L 132.8070068359375 417.3680114746094 L 142.8800048828125 422.0169982910156 L 154.5019989013672 424.34100341796875 L 154.5019989013672 428.989990234375 L 147.91600036621094 431.31500244140625 L 130.09500122070312 429.7650146484375 L 109.56199645996094 425.8909912109375 L 83.21800231933594 426.6659851074219 L 77.01899719238281 423.9540100097656 L 72.37000274658203 418.14300537109375 L 74.69499969482422 401.4840087890625 L 75.47000122070312 388.6990051269531 L 73.1449966430664 376.302001953125 L 67.72100067138672 361.9679870605469 L 53 330.9750061035156 L 44.0890007019043 305.7929992675781 L 39.053001403808594 276.3489990234375 L 39.82699966430664 257.3659973144531 L 39.439998626708984 223.2740020751953 L 19.68199920654297 148.88999938964844 L 7.671999931335449 100.46399688720703 L 4.960000038146973 79.93099975585938 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'FEBCF571-FBBD-43F2-9955-2DFDF71A9AF0'
    ) {
      pathString =
        'M 157.6009979248047 80.31800079345703 L 152.56500244140625 107.05000305175781 L 143.26699829101562 148.88999938964844 L 123.12200164794922 221.7239990234375 L 121.18499755859375 237.60800170898438 L 121.95899963378906 255.8159942626953 L 123.50900268554688 275.18701171875 L 120.41000366210938 297.6570129394531 L 109.56199645996094 331.36199951171875 L 94.83999633789062 361.1929931640625 L 88.25399780273438 379.78900146484375 L 86.70500183105469 389.4739990234375 L 89.80400085449219 414.26800537109375 L 86.31700134277344 422.7919921875 L 78.56900024414062 428.2149963378906 L 56.0989990234375 425.50299072265625 L 48.35100173950195 426.6659851074219 L 22.7810001373291 431.7019958496094 L 9.609000205993652 430.927001953125 L 5.735000133514404 426.27801513671875 L 8.833999633789062 423.9540100097656 L 21.23200035095215 422.0169982910156 L 47.9630012512207 405.3580017089844 L 58.81100082397461 389.8609924316406 L 66.1719970703125 362.3550109863281 L 71.98300170898438 332.1369934082031 L 77.01899719238281 298.8190002441406 L 83.6050033569336 244.968994140625 L 80.89299774169922 223.66099548339844 L 82.44300079345703 200.0290069580078 L 78.18199920654297 150.05299377441406 L 77.01899719238281 139.2050018310547 L 77.79399871826172 96.58899688720703 L 85.15499877929688 54.749000549316406 L 157.16799926757812 54.49800109863281 Z';
    }

    // Front Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'BF2FE431-D5DB-4871-A6DB-556088568545'
    ) {
      pathString =
        'M 108.013 331.362 L 103.751 375.14 L 106.075 386.375 L 105.688 399.159 L 107.625 409.232 L 102.976 416.98 L 92.516 418.143 L 84.38 420.854 L 70.821 428.215 L 60.748 428.603 L 56.486 427.053 L 51.45 427.441 L 47.576 427.828 L 42.152 425.503 L 40.99 421.242 L 44.089 416.593 L 57.261 411.169 L 68.884 402.646 L 77.407 391.798 L 80.119 375.14 L 82.056 360.805 L 80.119 331.363 L 108.013 331.362 Z';
    }

    // Front Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'E4C6DD52-8766-448A-87E5-6A385907D2A7'
    ) {
      pathString =
        'M 69.791 332.267 L 67.768 360.083 L 72.826 390.932 L 90.021 410.15 L 106.71 416.725 L 108.227 426.839 L 95.078 428.357 L 81.929 428.357 L 68.78 423.299 L 49.056 416.725 L 43.493 407.116 L 42.987 388.404 L 45.516 360.588 L 40.459 331.761 L 69.791 332.267 Z';
    }

    // Outside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '99CE261D-9BC0-48BF-B1B9-C1998FF0713B'
    ) {
      pathString =
        'M 109.562 331.749 L 88.254 379.789 L 86.705 389.474 L 89.804 414.268 L 86.317 422.792 L 78.569 428.215 L 56.099 425.503 L 48.351 426.666 L 22.781 431.702 L 9.609 430.927 L 5.735 426.278 L 8.834 423.954 L 21.232 422.017 L 47.963 405.358 L 58.811 389.861 L 66.172 362.355 L 71.983 332.137 L 109.562 331.749 Z';
    }

    // Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'C41B4BA7-5032-4FA0-9512-ED97FC40FAE7'
    ) {
      pathString =
        'M 52.61199951171875 332.52398681640625 L 89.80400085449219 332.1369934082031 L 95.22799682617188 362.3550109863281 L 100.6520004272461 380.95098876953125 L 106.8499984741211 396.05999755859375 L 127.77100372314453 414.656005859375 L 141.7169952392578 422.40399169921875 L 154.5019989013672 423.9540100097656 L 154.11500549316406 429.37799072265625 L 147.5290069580078 431.31500244140625 L 130.09500122070312 429.37799072265625 L 108.78700256347656 425.50299072265625 L 82.83000183105469 427.0530090332031 L 74.30699920654297 423.9540100097656 L 71.98300170898438 414.656005859375 L 75.85700225830078 389.0870056152344 L 74.30699920654297 378.239013671875 L 66.94599914550781 361.1929931640625 Z';
    }

    // Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '8E77DCE9-2306-477F-AA50-82BD5FCE4818'
    ) {
      pathString =
        'M 53.608 333.279 L 65.745 360.588 L 75.86 382.841 L 70.297 415.713 L 78.389 426.839 L 104.181 425.322 L 125.928 429.874 L 150.709 431.391 L 154.249 425.828 L 137.054 419.759 C 137.054 419.759 119.301 411.162 119.353 410.656 C 119.405 410.15 109.338 401.047 108.227 401.047 L 94.067 363.117 L 89.009 332.267 L 53.608 333.279 Z';
    }

    // Backside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '0FC06F1D-7901-49E1-A06C-2BBD0B86FBC5'
    ) {
      pathString =
        'M 68.237 330.672 L 38.256 331.051 L 39.774 359.894 L 41.671 371.658 L 34.84 387.977 L 36.358 404.296 L 34.461 416.44 L 35.22 421.753 L 42.43 426.307 L 53.815 426.307 L 62.924 418.717 L 86.074 412.266 L 89.489 405.055 L 85.694 401.26 L 78.484 397.844 L 72.032 394.429 L 64.062 392.152 L 62.165 375.833 L 63.303 360.653 L 68.237 330.672 Z';
    }

    // Backside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '41F975D1-AE2D-45E5-8469-D61CD5977F4F'
    ) {
      pathString =
        'M 81.146 330.686 C 82.484 330.351 89.25 378.062 86.399 378.775 L 83.57 392.11 L 76.296 395.343 L 69.023 398.172 L 61.749 400.597 L 60.536 406.254 L 63.769 411.507 L 73.064 414.74 L 83.975 417.569 L 90.844 422.822 L 98.926 426.055 L 107.817 426.863 L 113.878 422.014 L 113.878 412.316 L 113.07 401.809 L 113.878 387.665 L 108.221 371.501 L 108.221 359.782 L 110.645 331.091 L 81.146 330.686 Z';
    }

    // Outside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'AD7D1F92-E57B-4C0F-961F-B80AA0E4DB75'
    ) {
      pathString =
        'M 52.61199951171875 332.52398681640625 L 89.80400085449219 332.1369934082031 L 95.22799682617188 362.3550109863281 L 100.6520004272461 380.95098876953125 L 106.8499984741211 396.05999755859375 L 127.77100372314453 414.656005859375 L 141.7169952392578 422.40399169921875 L 154.5019989013672 423.9540100097656 L 154.11500549316406 429.37799072265625 L 147.5290069580078 431.31500244140625 L 130.09500122070312 429.37799072265625 L 108.78700256347656 425.50299072265625 L 82.83000183105469 427.0530090332031 L 74.30699920654297 423.9540100097656 L 71.98300170898438 414.656005859375 L 75.85700225830078 389.0870056152344 L 74.30699920654297 378.239013671875 L 66.94599914550781 361.1929931640625 Z';
    }

    // Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'EC3F137F-5F75-4EAA-8407-3099D467D08B'
    ) {
      pathString =
        'M 81.281 255.816 L 121.959 255.816 L 123.509 275.187 L 120.41 297.657 L 109.562 331.362 L 94.84 361.193 L 88.254 379.789 L 86.705 389.474 L 89.804 414.268 L 86.317 422.792 L 78.569 428.215 L 56.099 425.503 L 48.351 426.666 L 22.781 431.702 L 9.609 430.927 L 5.735 426.278 L 8.834 423.954 L 21.232 422.017 L 47.963 405.358 L 58.811 389.861 L 66.172 362.355 L 71.983 332.137 L 77.019 298.819 Z';
    }

    // Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '4339966C-67D1-41DA-A1F0-267483BCB422'
    ) {
      pathString =
        'M 40.21500015258789 256.2040100097656 L 81.28099822998047 256.2040100097656 L 86.70500183105469 313.9280090332031 L 94.83999633789062 361.9679870605469 L 104.91300201416016 391.4110107421875 L 114.98600006103516 405.3580017089844 L 142.8800048828125 422.7919921875 L 153.7270050048828 423.9540100097656 L 154.88999938964844 429.37799072265625 L 150.6280059814453 431.31500244140625 L 133.19400024414062 430.5400085449219 L 105.68800354003906 425.1159973144531 L 85.93000030517578 427.0530090332031 L 77.01899719238281 424.72900390625 L 71.98300170898438 418.9169921875 L 75.08200073242188 390.635986328125 L 72.75800323486328 374.75201416015625 L 61.52299880981445 350.7330017089844 L 52.61199951171875 331.7489929199219 L 44.0890007019043 306.17999267578125 L 39.053001403808594 275.18701171875 Z';
    }

    // Front Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '229C5D04-BE25-4DD3-941A-BC0F9C058417'
    ) {
      pathString =
        'M 70.821 221.724 L 114.986 221.337 L 116.923 234.121 L 118.473 254.654 L 108.4 330.975 L 104.138 361.193 L 103.751 375.14 L 106.075 386.375 L 105.688 399.159 L 107.625 409.232 L 102.976 416.98 L 92.516 418.143 L 84.38 420.854 L 70.821 428.215 L 60.748 428.603 L 56.486 427.053 L 51.45 427.441 L 47.576 427.828 L 42.152 425.503 L 40.99 421.242 L 44.089 416.593 L 57.261 411.169 L 68.884 402.646 L 77.407 391.798 L 80.119 375.14 L 82.056 360.805 L 80.119 330.2 L 69.658 277.512 C 64.741 265.57 68.768 216.738 70.821 221.724 Z';
    }

    // Front Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '35B61532-49CB-4674-86F3-E87ECA83904A'
    ) {
      pathString =
        'M 35.179 221.337 L 79.731 222.499 L 83.218 255.429 L 70.046 330.2 C 69.156 329.31 66.941 360.025 68.109 361.193 L 71.595 391.411 L 87.479 408.457 L 106.075 416.206 L 109.175 421.629 L 106.85 426.666 L 101.814 427.828 L 94.453 427.441 L 88.254 429.378 L 77.019 425.891 L 61.523 418.53 L 49.513 417.368 L 43.702 410.007 L 44.476 399.934 L 44.476 387.537 L 46.414 372.815 L 45.639 360.031 L 41.765 330.975 L 32.467 255.429 L 32.854 238.383 L 35.179 221.337 Z';
    }

    // Backside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '5C7E70A7-C077-4DFD-AD70-DC8F766BA726'
    ) {
      pathString =
        'M 31.425 221.753 C 33.844 220.543 38.064 253.348 34.461 255.149 L 32.943 282.474 L 38.256 331.051 L 39.774 359.894 L 41.671 371.658 L 34.84 387.977 L 36.358 404.296 L 34.461 416.44 L 35.22 421.753 L 42.43 426.307 L 53.815 426.307 L 62.924 418.717 L 86.074 412.266 L 89.489 405.055 L 85.694 401.26 L 78.484 397.844 L 72.032 394.429 L 64.062 392.152 L 62.165 375.833 L 63.303 360.653 L 68.237 330.672 L 79.622 271.469 L 80.381 256.288 L 76.965 221.753 L 31.425 221.753 Z';
    }

    // Backside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '6154F266-2A51-476F-943F-F48B972283F8'
    ) {
      pathString =
        'M 72.66 222.386 C 71.732 222.386 68.208 255.523 69.427 255.523 C 68.818 255.523 70.983 280.578 71.447 280.578 L 81.954 331.091 L 86.399 360.59 L 86.399 378.775 L 83.57 392.11 L 76.296 395.343 L 69.023 398.172 L 61.749 400.597 L 60.536 406.254 L 63.769 411.507 L 73.064 414.74 L 83.975 417.569 L 90.844 422.822 L 98.926 426.055 L 107.817 426.863 L 113.878 422.014 L 113.878 412.316 L 113.07 401.809 L 113.878 387.665 L 108.221 371.501 L 108.221 359.782 L 110.645 331.495 L 116.707 287.851 L 114.687 254.715 L 114.282 236.126 L 118.323 221.982 C 113.9 222.867 72.305 222.457 72.66 222.386 Z';
    }

    // Outside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '4BF20430-5D87-40ED-B8DD-FD0CE6C84D5C'
    ) {
      pathString = '';
    }

    // Outside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '193CC13D-F070-4013-8D55-9BCA4B602B7C'
    ) {
      pathString =
        'M 81.281 255.816 L 121.959 255.816 L 123.509 275.187 L 120.41 297.657 L 109.562 331.362 L 94.84 361.193 L 88.254 379.789 L 86.705 389.474 L 89.804 414.268 L 86.317 422.792 L 78.569 428.215 L 56.099 425.503 L 48.351 426.666 L 22.781 431.702 L 9.609 430.927 L 5.735 426.278 L 8.834 423.954 L 21.232 422.017 L 47.963 405.358 L 58.811 389.861 L 66.172 362.355 L 71.983 332.137 L 77.019 298.819 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '6B4E1490-9E82-4F9A-9FB2-26719CF90930'
    ) {
      pathString =
        'M 119.518 79.713 L 121.621 95.036 L 121.32 111.861 L 114.11 141.304 L 115.011 178.559 L 121.02 226.329 L 127.029 238.948 L 127.329 247.961 L 124.926 261.181 L 132.136 331.184 L 26.68 332.085 L 43.806 250.665 L 41.402 232.338 L 44.707 220.321 L 14.062 122.977 L 12.259 98.641 L 36.295 98.641 L 36.595 80.615 L 113.208 80.014 L 119.518 79.713 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'BFA0649F-B79F-4653-92EC-3665AAAF4F15'
    ) {
      pathString =
        'M 22.775 108.255 C 21.869 109.161 27.192 134.483 27.882 133.793 L 29.985 156.026 L 27.281 195.083 L 22.775 226.329 L 16.465 240.45 L 16.465 248.262 L 19.47 260.88 L 11.358 330.583 L 117.114 329.381 C 117.352 329.381 100.311 250.665 99.087 250.665 C 102.282 250.665 103.076 232.038 102.692 232.038 C 102.692 232.038 100.89 219.119 99.688 219.119 C 99.983 219.414 119.111 161.929 118.616 161.434 C 120.206 161.434 129.878 122.076 129.132 122.076 L 131.535 98.641 L 125.226 98.641 L 107.5 98.942 L 107.5 81.215 L 25.178 80.615 C 22.763 80.615 19.603 108.255 22.775 108.255 Z';
    }

    // Front Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'E17E2ACC-35DE-4DF7-901F-3FDF24DDE1F3'
    ) {
      pathString =
        'M 58.423 62.497 L 140.943 62.497 L 128.933 126.808 L 67.721 126.808 C 66.139 127.599 55.918 63.75 58.423 62.497 Z';
    }

    // Back Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '1595C10F-EA23-4202-82C7-5BE23636F775'
    ) {
      pathString =
        'M 7.136000156402588 62.36000061035156 L 91.00700378417969 62.36000061035156 L 84.1760025024414 127.25599670410156 L 18.9010009765625 127.25599670410156 Z';
    }

    // Outside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'D33DF177-EA6A-49A1-A1D4-D27233081236'
    ) {
      pathString =
        'M 4.96 53.974 L 4.573 72.57 L 6.897 96.589 L 13.483 121.384 L 16.971 137.268 L 19.682 148.89 L 83.993 148.89 L 85.155 136.493 L 85.155 117.122 L 84.38 88.841 L 79.731 64.047 L 77.019 53.974 L 4.96 53.974 Z';
    }

    // Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'C78A4E57-11F0-427D-9AF7-258C4F0BE1FE'
    ) {
      pathString =
        'M 85.542 53.974 L 157.214 54.361 L 156.439 90.003 L 148.304 124.096 L 142.493 148.115 L 77.794 148.115 C 77.794 148.527 77.407 112.699 77.407 112.086 L 78.956 86.904 L 85.542 53.974 Z';
    }

    // Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '3BDB29BC-1983-4D38-80E2-28ACCE660C4E'
    ) {
      pathString =
        'M122.85,265.07c1.14,17.26-3,38.76-8.77,54.88-4.75,13.21,1.33-1.77-4.93,11.49L72.63,332c3.8-16.29,1-6.4,2.25-16.86,1.71-13.7,6-51.09,6.81-58.79h40.48Z';
    }
    // Outside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'B87D4FCE-601F-4685-85A0-6E0967882BEC'
    ) {
      pathString =
        'M39.45,266.22c-1.14,17.26,3,38.76,8.77,54.88,4.75,13.22-1.86-2.4,4.39,10.86L90,332c-3.08-16.27-1.28-5.29-2.58-15.75-1.72-13.7-6-52.24-6.86-59.94H39.83Z';
    }

    // Back Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'E941AA16-5CB2-4FFE-B81F-922F642E78D0'
    ) {
      pathString =
        'M78.81,264.29c-.6,8.1-3.6,22.89-7,40.1C68,323.28,69.4,314.76,67.5,331H38.35c-1.5-25.3-1.84-25.17-4-41.07-1.1-8.1-.2-17.9.8-27.4,1.4-13.9,2.81-28.4-2.1-38.5a22.45,22.45,0,0,1-.9-2.19H75.34C77.69,234.85,79.9,250.67,78.81,264.29Z';
    }

    // Front Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '7F3B931D-F5E2-4246-9961-09FA97240C6A'
    ) {
      pathString =
        'M114.5,221.78a31.43,31.43,0,0,0,.47,9c4,19.85.71,36.77-2,56.77-2.19,15.87-3,25.14-5,43.57l-28,0C77.61,306,68.15,283.61,66.41,261.92c-.88-10.83,1-26.75,3.12-40.14Z';
    }

    // Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'A73C0D1D-F4E4-4545-A323-2D3D30C7E13A'
    ) {
      pathString =
        'M4.152,63.497c0.735,29.212,5.406,43.467,5.406,43.467c1.078,3.539,4.007,14,8.519,36.454   c5.796,28.855,10.888,45.268,18.244,69.453c7.357,24.189,3.957,34.938,2.829,52.197c-1.133,17.258,2.967,38.759,8.77,54.883   c4.751,13.212,13.014,28.699,19.268,41.958h27.6c-3.804-16.292-6.363-36.349-7.67-46.812c-1.711-13.701-5.993-52.234-6.852-59.94   c-0.858-7.708-1.709-12.847-0.425-19.243c1.285-6.402,1.283-18.863-0.006-32.521c-1.283-13.659,5.144-51.421,5.144-66.836   c0-15.412-0.431-46.67-2.998-58.795c-1.001-4.723-1.875-9.325-2.918-14.265l-2.042-8.999H4.152V63.497z';
    }

    // Outside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '84689929-31E9-4114-959C-356DD9148010'
    ) {
      pathString =
        'M157.848,63.497c-0.734,29.212-5.406,43.467-5.406,43.467c-1.078,3.539-4.006,14-8.52,36.454   c-5.796,28.855-10.888,45.268-18.242,69.453c-7.357,24.189-3.957,34.938-2.83,52.197c1.133,17.258-2.968,38.759-8.771,54.883   c-4.751,13.212-13.013,28.699-19.269,41.958H67.213c3.803-16.292,6.363-36.349,7.67-46.812c1.71-13.701,5.992-52.234,6.852-59.94   c0.858-7.708,1.709-12.847,0.425-19.243c-1.285-6.402-1.283-18.863,0.006-32.521c1.282-13.659-5.142-51.421-5.142-66.836   c0-15.412,0.429-46.67,2.998-58.795c1-4.723,1.874-9.325,2.918-14.265l2.041-8.999h72.048L157.848,63.497z';
    }

    // Front Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '6683FE46-CCD5-4CC2-9CFF-20DB523D3DEC'
    ) {
      pathString =
        'M79.445,139.252c7.386-27.963,10.875-53.837,12.009-76.779H10.223   c4.188,33.143,15.363,79.06,15.555,99.029c0.25,26,0.75,36.5,3.25,42.693c2.5,6.192,7.25,15.002,4.953,26.542   c-3.951,19.85-0.703,36.77,2.047,56.77c2.183,15.875,7.358,54.901,9.4,73.327h22.596c-2.144-25.719,12.779-77.218,14.526-98.913   c1.773-22-7.772-65.059-7.772-65.059C69.445,163.805,79.445,139.252,79.445,139.252z';
    }

    // Back Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '83793D05-62F9-463E-BD83-D9321A6D3BBC'
    ) {
      pathString =
        'M68.788,141.265c1.8,11.799,3.2,21.099,3.5,25.798c0.2,2.9,0.9,5.6,1.6,8.5c1.2,4.7,2.5,9.5,1.5,15.6 v0.1c-0.9,3.1-0.7,8.5-0.6,13.799c0.1,4.9,0.3,9.5-0.4,12.799c-2.6,13.699-5.399,31.397-4.2,46.396c0.6,8.1,3.6,22.899,7,40.1 c3.801,18.897,7.899,39.598,9.801,55.797h20.299c1.5-25.299,5.199-54.397,7.398-70.297c1.101-8.1,0.201-17.898-0.799-27.398 c-1.4-13.898-2.801-28.398,2.1-38.497c1-2,1.8-5,2.699-8.1c0.899-3.2,1.801-6.5,3-9.5c2.399-6,2.899-16.299,3.199-42.297 c0.102-11.5,3.9-31.499,8-52.597c2.699-13.899,5.399-28.099,7.199-40.798l2.061-8.502H59.379 C60.836,89.535,65.458,119.647,68.788,141.265z';
    }

    // Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '06F4FAFF-4708-4D61-AA4D-4D96D44B3598'
    ) {
      pathString =
        'M157.848,63.497c-0.734,29.212-5.406,43.467-5.406,43.467c-1.078,3.539-4.006,14-8.52,36.454   c-5.796,28.855-10.888,45.268-18.242,69.453c-7.357,24.189-3.957,34.938-2.83,52.197c1.133,17.258-2.968,38.759-8.771,54.883   c-1.388,3.857-3.079,7.914-4.929,12.049H72.626c0.963-6.637,1.718-12.59,2.257-16.9c1.71-13.703,5.992-52.236,6.852-59.942   c0.858-7.708,1.709-12.847,0.425-19.243c-1.285-6.402-1.283-18.863,0.006-32.521c1.282-13.659-5.142-51.421-5.142-66.836   c0-15.412,0.429-46.67,2.998-58.795c1-4.723,1.874-9.325,2.918-14.265l2.042-8.999h72.047L157.848,63.497z';
    }

    // Outside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '6C550EEC-E6E6-426F-8A09-0D0BF45CC054'
    ) {
      pathString =
        'M4.152,63.497c0.735,29.212,5.406,43.467,5.406,43.467c1.078,3.539,4.007,14,8.519,36.454   c5.796,28.855,10.888,45.268,18.244,69.453c7.357,24.189,3.957,34.938,2.829,52.197c-1.133,17.258,2.967,38.759,8.77,54.883   c1.388,3.857,3.08,7.914,4.929,12.049h36.525c-0.963-6.637-1.718-12.59-2.257-16.9c-1.71-13.703-5.992-52.236-6.851-59.942   c-0.858-7.708-1.709-12.847-0.425-19.243c1.285-6.402,1.283-18.863-0.006-32.521c-1.283-13.659,5.144-51.421,5.144-66.836   c0-15.412-0.431-46.67-2.998-58.795c-1.001-4.723-1.875-9.325-2.918-14.265l-2.042-8.999H4.152V63.497z';
    }

    // Back Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'C3B6DAAA-DBF8-4FE9-A110-3E9C047A3C80'
    ) {
      pathString =
        'M76.712,167.091c-0.2,2.9-0.899,5.6-1.601,8.5c-1.199,4.7-2.5,9.5-1.5,15.6v0.1    c0.9,3.1,0.7,8.499,0.6,13.8c-0.1,4.899-0.299,9.499,0.4,12.8c2.601,13.698,5.399,31.397,4.2,46.396c-0.6,8.1-3.601,22.899-7,40.1    c-1.746,8.685-3.554,17.746-5.184,26.58h-27.34c-1.642-16.079-3.6-31.151-4.974-41.08c-1.1-8.1-0.2-17.897,0.8-27.397    c1.4-13.898,2.801-28.398-2.1-38.498c-1-2-1.8-5-2.699-8.099c-0.9-3.2-1.801-6.5-3-9.5c-2.4-5.999-2.9-16.298-3.2-42.297    c-0.101-11.5-3.899-31.499-7.999-52.597c-2.7-13.899-5.4-28.099-7.2-40.798l-2.06-8.502H89.62    c-1.457,27.369-6.079,57.481-9.409,79.099C78.411,153.092,77.012,162.392,76.712,167.091z';
    }

    // Front Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '24CBE8BE-DE15-4026-B34B-AF64BAB3C7AA'
    ) {
      pathString =
        'M121.425,204.195c-2.5,6.193-7.25,15.002-4.953,26.542c3.951,19.85,0.703,36.77-2.047,56.77   c-1.292,9.394-3.631,26.892-5.749,43.433H80.373c-3.826-25.044-11.268-54.088-12.471-69.019c-1.773-22,7.772-65.059,7.772-65.059   c5.333-33.057-4.667-57.609-4.667-57.609c-7.386-27.963-10.875-53.837-12.009-76.779h81.231   c-4.188,33.143-15.362,79.06-15.555,99.029C124.425,187.502,123.925,198.002,121.425,204.195z';
    }

    // Front Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '46502E46-4B74-418E-B37D-8900E2DFDB35'
    ) {
      pathString =
        'M 58.423 62.497 L 140.943 62.497 L 128.933 126.808 L 67.721 126.808 C 66.139 127.599 55.918 63.75 58.423 62.497 Z';
    }

    // Backside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '42EC0883-33E0-4547-855C-22886D699F1E'
    ) {
      pathString =
        'M 7.136000156402588 62.36000061035156 L 91.00700378417969 62.36000061035156 L 84.1760025024414 127.25599670410156 L 18.9010009765625 127.25599670410156 Z';
    }

    // Outside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '9580D0FF-57EE-4885-B756-76A284AA197D'
    ) {
      pathString =
        'M 4.96 53.974 L 4.573 72.57 L 6.897 96.589 L 13.483 121.384 L 16.971 137.268 L 19.682 148.89 L 83.993 148.89 L 85.155 136.493 L 85.155 117.122 L 84.38 88.841 L 79.731 64.047 L 77.019 53.974 L 4.96 53.974 Z';
    }

    // Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '90112F0A-C259-4290-B17B-5A782EAACF53'
    ) {
      pathString =
        'M 85.542 53.974 L 157.214 54.361 L 156.439 90.003 L 148.304 124.096 L 142.493 148.115 L 77.794 148.115 C 77.794 148.527 77.407 112.699 77.407 112.086 L 78.956 86.904 L 85.542 53.974 Z';
    }

    // Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '0170900E-BDCE-4D9A-9FAE-521F053E58C9'
    ) {
      pathString =
        'M39.447,266.22c-1.133,17.258,2.967,38.759,8.77,54.883c4.751,13.212,13.014,28.699,19.268,41.958 h27.601c-3.805-16.292-6.363-36.349-7.67-46.812c-1.713-13.701-5.995-52.234-6.854-59.94H39.833L39.447,266.22z';
    }

    // Outside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'B4BB428B-4138-42E3-BC61-B149EA27BC98'
    ) {
      pathString =
        'M122.852,265.068c1.133,17.258-2.969,38.759-8.771,54.883c-4.751,13.212-13.014,28.699-19.268,41.958 h-27.6c3.803-16.292,6.363-36.349,7.67-46.812c1.71-13.701,5.945-51.083,6.805-58.789h40.479L122.852,265.068z';
    }

    // Backside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '5875FE57-5E39-4462-BC0B-7948FFF09E55'
    ) {
      pathString =
        'M70.188,264.258c0.6,8.1,3.6,22.899,7,40.1c3.801,18.897,7.899,39.598,9.801,55.797h20.299 c1.5-25.299,5.199-54.397,7.398-70.297c1.101-8.1,0.201-17.898-0.799-27.398c-1.4-13.898-2.801-28.398,2.1-38.497 c0.318-0.637,0.613-1.382,0.9-2.19H73.665C71.305,234.822,69.099,250.646,70.188,264.258z';
    }

    // Front Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'D619B0EE-1D58-4192-B787-CF565A21CEBE'
    ) {
      pathString =
        'M34.453,221.78c0.248,2.78,0.165,5.759-0.472,8.956c-3.951,19.85-0.703,36.77,2.047,56.77 c2.183,15.875,7.358,54.901,9.4,73.327h22.596c-2.144-25.72,12.779-77.218,14.526-98.913c0.873-10.827-0.995-26.754-3.118-40.141 L34.453,221.78L34.453,221.78z';
    }

    // Front Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '98CE5BAB-F883-42BB-9DBD-A58CB278E760'
    ) {
      pathString =
        'M 58.423 62.497 L 140.943 62.497 L 128.933 126.808 L 67.721 126.808 C 66.139 127.599 55.918 63.75 58.423 62.497 Z';
    }

    // Backside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '133555FC-245C-4347-A6FA-C80C34A6DBC9'
    ) {
      pathString =
        'M 7.136000156402588 62.36000061035156 L 91.00700378417969 62.36000061035156 L 84.1760025024414 127.25599670410156 L 18.9010009765625 127.25599670410156 Z';
    }

    // Outside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '367D6C19-2599-4A2F-9A36-DAE0123A8278'
    ) {
      pathString =
        'M 4.960000038146973 53.9739990234375 L 4.572999954223633 72.56999969482422 L 6.896999835968018 96.58899688720703 L 13.482999801635742 121.38400268554688 L 19.295000076293945 148.5030059814453 L 26.26799964904785 179.49600219726562 L 39.439998626708984 222.88600158691406 L 80.89299774169922 223.66099548339844 L 80.11900329589844 196.54200744628906 L 82.05599975585938 171.7480010986328 L 83.99299621582031 148.88999938964844 L 85.15499877929688 117.12200164794922 L 84.37999725341797 88.84100341796875 L 79.73100280761719 64.0469970703125 L 77.01899719238281 53.9739990234375 Z';
    }

    // Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'E5AAA1D3-626D-443A-A967-934FDB2E49C9'
    ) {
      pathString =
        'M 85.54199981689453 53.9739990234375 L 157.21400451660156 54.361000061035156 L 156.43899536132812 90.00299835205078 L 142.49200439453125 148.11500549316406 L 132.8070068359375 190.343994140625 L 123.12200164794922 223.66099548339844 L 81.28099822998047 223.66099548339844 L 81.28099822998047 214.75100708007812 L 82.44300079345703 190.7310028076172 L 77.79399871826172 148.5030059814453 L 77.40699768066406 110.92400360107422 L 78.95600128173828 86.90399932861328 Z';
    }

    // Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'CC467087-A8FC-42E1-8C59-A6BFDEA3A13F'
    ) {
      pathString =
        'M 4.96 53.974 L 77.407 54.361 L 83.993 86.904 L 84.768 119.834 C 88.121 119.587 77.388 193.396 81.281 223.273 L 39.441 223.274 C 38.698 225.981 11.572 128.423 14.646 122.546 C 4.7 100.664 5.704 84.9 5.735 84.967 L 4.96 53.974 Z';
    }

    // Outside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '38AC4491-E2C8-4D9C-9F6B-4BBCC4E6F23C'
    ) {
      pathString =
        'M 84.37999725341797 54.361000061035156 L 157.6009979248047 53.9739990234375 L 157.21400451660156 81.86799621582031 L 154.88999938964844 99.3010025024414 L 149.46600341796875 117.89700317382812 L 142.49200439453125 149.6649932861328 L 133.968994140625 185.3070068359375 L 123.12200164794922 224.04800415039062 L 80.50599670410156 223.2740020751953 L 82.05599975585938 196.15499877929688 L 79.73100280761719 165.93600463867188 L 77.40699768066406 148.88999938964844 L 77.40699768066406 122.15899658203125 L 78.56900024414062 86.90399932861328 Z';
    }

    // Backside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '24C52476-7839-4B4A-AD19-539E76B52040'
    ) {
      pathString =
        'M 58.11199951171875 62.361000061035156 L 142.9739990234375 62.361000061035156 L 130.8509979248047 126.61399841308594 L 126.0009994506836 162.98300170898438 L 125.19300079345703 195.71600341796875 L 73.46800231933594 195.71600341796875 L 75.08399963378906 183.99600219726562 L 72.25499725341797 174.70199584960938 L 65.79000091552734 127.4219970703125 Z';
    }

    // Front Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'AEE9B116-C6CD-42F5-BE92-5671D3A0EE46'
    ) {
      pathString =
        'M27.019,195.25H74.54c-4.758-32.237,4.905-55.998,4.905-55.998 c7.387-27.963,10.875-53.837,12.01-76.779H10.223c4.188,33.143,15.363,79.06,15.555,99.029 C25.938,178.099,26.2,188.373,27.019,195.25z';
    }

    // Front Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'D82F8E43-DE2B-4987-934C-52BBE9045981'
    ) {
      pathString =
        'M 58.423 62.497 L 140.943 62.497 L 128.933 126.808 L 67.721 126.808 C 66.139 127.599 55.918 63.75 58.423 62.497 Z';
    }

    // Backside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'BBADDA02-7A45-4BE8-8C5C-F41904033671'
    ) {
      pathString =
        'M 7.136000156402588 62.36000061035156 L 91.00700378417969 62.36000061035156 L 84.1760025024414 127.25599670410156 L 18.9010009765625 127.25599670410156 Z';
    }

    // Outside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'C8C4E143-612E-4390-8B7A-15D94ACADCF8'
    ) {
      pathString =
        'M 4.96 53.974 L 4.573 72.57 L 6.897 96.589 L 13.483 121.384 L 16.971 137.268 L 19.682 148.89 L 83.993 148.89 L 85.155 136.493 L 85.155 117.122 L 84.38 88.841 L 79.731 64.047 L 77.019 53.974 L 4.96 53.974 Z';
    }

    // Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '4C0762F6-498A-40BA-8146-36D90FD22AC2'
    ) {
      pathString =
        'M 85.542 53.974 L 157.214 54.361 L 156.439 90.003 L 148.304 124.096 L 142.493 148.115 L 77.794 148.115 C 77.794 148.527 77.407 112.699 77.407 112.086 L 78.956 86.904 L 85.542 53.974 Z';
    }

    // Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'D0E8E902-D915-4F67-ADFB-B923754D93D5'
    ) {
      pathString =
        'M 4.960000038146973 53.9739990234375 L 77.40699768066406 54.361000061035156 L 83.99299621582031 86.90399932861328 L 85.15499877929688 119.83399963378906 L 84.76799774169922 148.11500549316406 L 19.295000076293945 148.5030059814453 L 9.996999740600586 107.43699645996094 L 5.735000133514404 84.96700286865234 Z';
    }

    // Outside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '46D7FB94-48A7-4BF4-8467-E8CEDAFACE8B'
    ) {
      pathString =
        'M 84.38 54.361 L 157.601 53.974 L 157.214 81.868 L 154.89 99.301 C 154.403 98.856 143.496 148.306 142.105 148.503 L 77.407 148.89 L 77.407 122.159 L 78.569 86.904 L 84.38 54.361 Z';
    }

    // Backside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'B9D7C672-1C0B-41CC-AFEF-61994CE1AE60'
    ) {
      pathString =
        'M 58.112 62.361 L 142.974 62.361 L 130.85 127.018 L 64.578 126.614 L 58.112 62.361 Z';
    }

    // Front Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '85BE97F7-3356-4B94-B412-46659D9EDB49'
    ) {
      pathString =
        'M 21.618999481201172 126.41999816894531 L 83.21800231933594 126.80799865722656 L 89.41699981689453 89.61599731445312 L 91.35399627685547 62.88399887084961 L 92.12799835205078 38.09000015258789 L 90.5790023803711 9.034000396728516 L 7.671999931335449 9.034000396728516 L 8.833999633789062 45.45100021362305 L 9.996999740600586 62.11000061035156 L 15.032999992370605 92.71499633789062 Z';
    }

    // Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'C8E2A1B9-7416-45A6-B063-AB558BD955D5'
    ) {
      pathString =
        'M4.152,63.497c0.735,29.212,5.406,43.467,5.406,43.467c1.078,3.539,4.007,14,8.519,36.454   c5.796,28.855,10.888,45.268,18.244,69.453c7.357,24.189,3.957,34.938,2.829,52.197c-1.133,17.258,2.967,38.759,8.77,54.883   c4.751,13.212,13.014,28.699,19.268,41.958h27.6c-3.804-16.292-6.363-36.349-7.67-46.812c-1.711-13.701-5.993-52.234-6.852-59.94   c-0.858-7.708-1.709-12.847-0.425-19.243c1.285-6.402,1.283-18.863-0.006-32.521c-1.283-13.659,5.144-51.421,5.144-66.836   c0-15.412-0.431-46.67-2.998-58.795c-1.001-4.723-1.875-9.325-2.918-14.265l-2.042-8.999H4.152V63.497z';
    }

    // Outside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'C00042EE-1D32-4691-A1BE-451910F21149'
    ) {
      pathString =
        'M157.848,63.497c-0.734,29.212-5.406,43.467-5.406,43.467c-1.078,3.539-4.006,14-8.52,36.454   c-5.796,28.855-10.888,45.268-18.242,69.453c-7.357,24.189-3.957,34.938-2.83,52.197c1.133,17.258-2.968,38.759-8.771,54.883   c-4.751,13.212-13.013,28.699-19.269,41.958H67.213c3.803-16.292,6.363-36.349,7.67-46.812c1.71-13.701,5.992-52.234,6.852-59.94   c0.858-7.708,1.709-12.847,0.425-19.243c-1.285-6.402-1.283-18.863,0.006-32.521c1.282-13.659-5.142-51.421-5.142-66.836   c0-15.412,0.429-46.67,2.998-58.795c1-4.723,1.874-9.325,2.918-14.265l2.041-8.999h72.048L157.848,63.497z';
    }

    // Front Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '7DCC7A1D-7014-4477-AE06-FACA79C25845'
    ) {
      pathString =
        'M79.445,139.252c7.386-27.963,10.875-53.837,12.009-76.779H10.223   c4.188,33.143,15.363,79.06,15.555,99.029c0.25,26,0.75,36.5,3.25,42.693c2.5,6.192,7.25,15.002,4.953,26.542   c-3.951,19.85-0.703,36.77,2.047,56.77c2.183,15.875,7.358,54.901,9.4,73.327h22.596c-2.144-25.719,12.779-77.218,14.526-98.913   c1.773-22-7.772-65.059-7.772-65.059C69.445,163.805,79.445,139.252,79.445,139.252z';
    }

    // Backside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '85818159-C7AC-4D36-B5B8-268A2B0A3076'
    ) {
      pathString =
        'M68.788,141.265c1.8,11.799,3.2,21.099,3.5,25.798c0.2,2.9,0.9,5.6,1.6,8.5c1.2,4.7,2.5,9.5,1.5,15.6 v0.1c-0.9,3.1-0.7,8.5-0.6,13.799c0.1,4.9,0.3,9.5-0.4,12.799c-2.6,13.699-5.399,31.397-4.2,46.396c0.6,8.1,3.6,22.899,7,40.1 c3.801,18.897,7.899,39.598,9.801,55.797h20.299c1.5-25.299,5.199-54.397,7.398-70.297c1.101-8.1,0.201-17.898-0.799-27.398 c-1.4-13.898-2.801-28.398,2.1-38.497c1-2,1.8-5,2.699-8.1c0.899-3.2,1.801-6.5,3-9.5c2.399-6,2.899-16.299,3.199-42.297 c0.102-11.5,3.9-31.499,8-52.597c2.699-13.899,5.399-28.099,7.199-40.798l2.061-8.502H59.379 C60.836,89.535,65.458,119.647,68.788,141.265z';
    }

    // Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'F5CFDCC2-EB37-4EA7-ABFA-B7106202E6B5'
    ) {
      pathString =
        'M157.848,63.497c-0.734,29.212,5.406,43.467,5.406,43.467c1.078,3.539,4.006,14,8.52,36.454   c5.796,28.855,10.888,45.268,18.242,69.453c7.357,24.189,3.957,34.938,2.83,52.197c-1.133,17.258-2.968,38.759-8.771,54.883   c-4.751,13.212-13.013,28.699-19.269,41.958H67.213c3.803-16.292,6.363-36.349,7.67-46.812c1.71-13.701,5.992-52.234,6.852-59.94   c0.858-7.708,1.709-12.847,0.425-19.243c-1.285-6.402-1.283-18.863,0.006-32.521c1.282-13.659-5.142-51.421-5.142-66.836   c0-15.412,0.429-46.67,2.998-58.795c1-4.723,1.874-9.325,2.918-14.265l2.041-8.999h72.048L157.848,63.497z';
    }

    // Outside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'DABC6919-CCB0-4770-90A1-2DB0567ED467'
    ) {
      pathString =
        'M4.152,63.497c0.735,29.212,5.406,43.467,5.406,43.467c1.078,3.539,4.007,14,8.519,36.454   c5.796,28.855,10.888,45.268,18.244,69.453c7.357,24.189,3.957,34.938,2.829,52.197c-1.133,17.258,2.967,38.759,8.77,54.883   c4.751,13.212,13.014,28.699,19.268,41.958h27.6c-3.804-16.292-6.363-36.349-7.67-46.812c-1.711-13.701-5.993-52.234-6.852-59.94   c-0.858-7.708-1.709-12.847-0.425-19.243c1.285-6.402,1.283-18.863-0.006-32.521c-1.283-13.659,5.144-51.421,5.144-66.836   c0-15.412-0.431-46.67-2.998-58.795c-1.001-4.723-1.875-9.325-2.918-14.265l-2.042-8.999H4.152V63.497z';
    }

    // Backside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '7608859F-AF42-41B7-B331-4D5F2A960E99'
    ) {
      pathString =
        'M80.211,141.293c-1.8,11.799-3.199,21.099-3.5,25.798c-0.2,2.9-0.899,5.6-1.601,8.5    c-1.199,4.7-2.5,9.5-1.5,15.6v0.1c0.9,3.1,0.7,8.499,0.6,13.8c-0.1,4.899-0.299,9.499,0.4,12.8    c2.601,13.698,5.399,31.397,4.2,46.396c-0.6,8.1-3.601,22.899-7,40.1c-3.8,18.898-7.899,39.599-9.8,55.798H41.713    c-1.5-25.3-5.199-54.398-7.399-70.298c-1.1-8.1-0.2-17.897,0.8-27.397c1.4-13.898,2.801-28.398-2.1-38.498c-1-2-1.8-5-2.699-8.099    c-0.9-3.2-1.801-6.5-3-9.5c-2.4-5.999-2.9-16.298-3.2-42.297c-0.101-11.5-3.899-31.499-7.999-52.597    c-2.7-13.899-5.4-28.099-7.2-40.798l-2.06-8.502H89.62C88.163,89.563,83.541,119.675,80.211,141.293z';
    }

    // Front Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '66AF5FF3-26DB-4D47-AD3F-B96258CE9835'
    ) {
      pathString =
        'M70.892,139.252c-7.386-27.963-10.875-53.837-12.01-76.779h81.232   c-4.188,33.143-15.363,79.06-15.556,99.029c-0.25,26-0.75,36.5-3.25,42.693s-7.25,15.002-4.953,26.542   c3.951,19.85,0.703,36.77-2.047,56.77c-2.183,15.875-7.357,54.901-9.399,73.327H82.313c2.144-25.719-12.778-77.218-14.527-98.913   c-1.773-22,7.772-65.059,7.772-65.059C80.892,163.804,70.892,139.252,70.892,139.252z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '7C51E8D2-304A-4A84-9F28-A147FE1CA820'
    ) {
      pathString =
        'M 13.761 99.542 L 36.295 98.641 L 36.295 80.314 L 117.414 80.615 L 121.921 94.435 L 118.015 127.183 L 114.11 146.712 L 115.011 180.061 L 118.015 207.101 L 40.801 207.101 L 14.062 123.578';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '994336C4-7A4C-4A76-BBD9-26009DD7782E'
    ) {
      pathString =
        'M 96.724 139.535 L 121.376 31.517 L 138.856 43.619 L 153.198 62.892 L 160.37 80.372 L 163.059 95.162 L 163.955 106.816 L 173.368 137.294 L 181.435 170.461 L 187.262 199.594 L 192.192 236.347 L 194.433 250.689 L 199.812 259.653 L 210.569 266.825 L 226.704 281.167 L 240.598 298.199 L 277.351 343.468 L 304.692 373.498 L 322.173 390.081 C 374.345 379.99 339.766 523.012 292.143 424.144 C 294.316 421.731 260.617 404.029 260.768 403.527 L 232.979 382.91 L 184.124 337.193 L 162.611 312.99 L 152.75 303.129 L 143.786 293.717 L 139.752 290.131 L 136.166 276.237 L 119.583 250.689 L 109.274 223.797 L 100.31 192.871 L 96.276 157.463 L 96.724 139.535 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'AD7DA77D-4A14-4EF5-8E2A-91832367C292'
    ) {
      pathString =
        'M 336.066 136.845 L 311.863 28.38 L 294.831 40.481 L 286.315 51.238 L 276.455 67.822 L 270.628 84.405 L 269.284 99.644 L 267.491 108.608 L 256.286 146.706 L 245.529 196.905 L 242.839 224.245 L 240.598 240.381 L 236.116 252.482 L 228.945 259.653 L 218.188 265.48 L 203.397 280.271 L 194.433 291.028 L 173.816 317.92 L 152.75 343.916 L 121.376 375.739 L 109.722 385.151 C 49.762 404.827 104.436 509.197 141.545 420.559 L 146.475 414.284 L 161.714 406.665 L 198.915 379.324 L 249.114 333.607 L 278.248 301.337 L 286.764 293.717 L 293.039 285.649 L 296.624 271.307 L 310.967 248.448 L 323.965 220.66 L 334.273 180.321 C 335.468 180.321 337.261 136.845 336.066 136.845 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '19D050B2-0AE0-4FE3-BA9A-1FF2996CD830'
    ) {
      pathString =
        'M 96.724 139.535 L 121.376 31.517 L 138.856 43.619 L 153.198 62.892 L 160.37 80.372 L 163.059 95.162 L 163.955 106.816 L 173.368 137.294 L 181.435 170.461 L 187.262 199.594 L 192.192 236.347 L 194.433 250.689 L 199.812 259.653 L 210.569 266.825 L 226.704 281.167 L 240.598 298.199 L 277.351 343.468 L 304.692 373.498 L 321.276 389.185 L 291.246 423.248 L 260.768 403.527 L 232.979 382.91 L 184.124 337.193 L 162.611 312.99 L 152.75 303.129 L 143.786 293.717 L 139.752 290.131 L 136.166 276.237 L 119.583 250.689 L 109.274 223.797 L 100.31 192.871 L 96.276 157.463 L 96.724 139.535 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '73403ECF-BE9F-4CF3-9089-7AD6F77F0826'
    ) {
      pathString =
        'M 336.066 136.845 L 311.863 28.38 L 294.831 40.481 L 286.315 51.238 L 276.455 67.822 L 270.628 84.405 L 269.284 99.644 L 267.491 108.608 L 256.286 146.706 L 245.529 196.905 L 242.839 224.245 L 240.598 240.381 L 236.116 252.482 L 228.945 259.653 L 218.188 265.48 L 203.397 280.271 L 194.433 291.028 L 173.816 317.92 L 152.75 343.916 L 121.376 375.739 L 109.722 385.151 L 141.545 420.559 L 146.475 414.284 L 161.714 406.665 L 198.915 379.324 L 249.114 333.607 L 278.248 301.337 L 286.764 293.717 L 293.039 285.649 L 296.624 271.307 L 310.967 248.448 L 323.965 220.66 L 334.273 180.321 C 335.468 180.321 337.261 136.845 336.066 136.845 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '601ECE3A-13D8-4370-A661-DE15F85897BD'
    ) {
      pathString =
        'M 96.276 157.463 L 175.161 142.672 L 181.435 170.461 L 187.262 199.594 L 192.192 236.347 L 194.433 250.689 L 199.812 259.653 L 210.569 266.825 L 226.704 281.167 L 240.598 298.199 L 277.351 343.468 L 304.692 373.498 L 322.173 390.081 C 322.501 388.232 292.796 422.766 292.143 424.144 C 294.316 421.731 260.617 404.029 260.768 403.527 L 232.979 382.91 L 184.124 337.193 L 162.611 312.99 L 152.75 303.129 L 143.786 293.717 L 139.752 290.131 L 136.166 276.237 L 119.583 250.689 L 109.274 223.797 L 100.31 192.871 L 96.276 157.463 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '5E1A9F09-A2CB-480C-884E-8ADD3C8BD09C'
    ) {
      pathString =
        'M 334.721 154.325 L 258.975 139.535 L 245.529 196.905 L 242.839 224.245 L 240.598 240.381 L 236.116 252.482 L 228.945 259.653 L 218.188 265.48 L 203.397 280.271 L 194.433 291.028 L 173.816 317.92 L 152.75 343.916 L 121.376 375.739 L 109.722 385.151 C 109.373 385.106 141.637 420.901 141.545 420.559 L 146.475 414.284 L 161.714 406.665 L 198.915 379.324 L 249.114 333.607 L 278.248 301.337 L 286.764 293.717 L 293.039 285.649 L 296.624 271.307 L 310.967 248.448 L 323.965 220.66 L 334.273 180.321 C 335.468 180.321 335.916 154.325 334.721 154.325 Z';
    }

    // Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      'F8A1A0BB-3701-4CA4-BC34-5CE824ABF8F6'
    ) {
      pathString =
        'M 164.909 335.933 L 172.606 364.316 L 184.633 390.293 L 181.266 407.611 L 170.682 484.1 L 166.353 536.055 L 328.47 534.13 L 326.065 489.873 L 311.152 421.562 L 309.228 408.092 L 328.951 383.077 L 332.319 376.824 L 370.323 321.021 L 381.868 295.043 L 341.94 262.812 L 335.205 262.812 L 326.546 241.646 L 324.622 233.468 L 322.698 207.009 L 282.288 195.945 L 279.402 197.388 L 277.478 194.021 L 229.853 193.54 L 226.004 192.096 L 187.038 200.755 L 181.266 215.187 L 172.606 216.149 L 149.997 258.002 L 164.909 335.933 Z';
    }

    // Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      '81DE1868-3202-45BB-A684-6106EA9A6A1B'
    ) {
      pathString =
        'M 139.731 293.146 L 180.785 260.014 L 190.149 250.651 L 195.911 232.644 L 198.072 206.715 L 236.245 190.149 L 291.706 189.429 L 333.481 197.351 L 336.362 205.995 L 339.963 213.197 L 345.725 211.757 L 366.613 258.574 L 360.13 311.153 L 350.767 348.606 L 343.564 369.494 L 337.082 381.738 L 356.529 530.112 L 193.75 528.671 L 193.03 489.777 L 213.197 403.346 L 193.03 380.298 L 147.653 315.474 L 139.731 293.146 Z';
    }

    // Right Palm
    if (
      image?.imageIdentity?.toUpperCase() ==
      'CA3F21B5-4653-44CF-A0AB-C20EF9BA0C26'
    ) {
      pathString =
        'M 140.737 303.673 L 150.935 319.213 L 187.358 377.488 L 207.754 399.341 L 194.642 454.703 C 191.652 454.703 186.817 526.09 187.358 526.09 L 351.015 527.062 L 334.018 399.827 L 330.618 381.373 L 342.273 357.092 L 349.558 334.753 L 363.641 254.139 L 371.897 232.285 L 342.759 205.576 L 337.903 207.518 L 332.075 203.633 L 329.161 192.464 L 283.027 184.208 L 232.035 186.636 L 191.728 200.234 L 191.243 230.343 L 179.587 254.624 L 172.303 253.653 L 134.424 286.676 L 140.737 303.673 Z';
    }

    // Left Palm
    if (
      image?.imageIdentity?.toUpperCase() ==
      'B12D538B-92FA-4601-9F6A-D27BE8301715'
    ) {
      pathString =
        'M 166.475 345.437 L 172.789 370.689 L 183.958 392.057 L 170.846 480.927 L 165.019 538.231 L 328.19 536.774 L 323.819 478.499 L 313.621 436.249 L 308.279 411.482 L 309.736 406.14 L 328.676 386.229 L 344.216 361.462 L 361.699 335.724 L 373.839 317.27 L 380.638 296.874 L 342.759 263.365 L 339.845 265.308 L 335.475 265.308 L 327.219 249.282 L 323.334 236.17 L 324.791 222.573 L 322.363 206.547 L 280.598 198.777 L 229.122 195.377 L 185.901 201.205 L 186.386 204.604 L 185.415 209.946 L 180.559 217.716 L 172.303 218.688 L 150.45 260.937 L 166.475 345.437 Z';
    }

    // Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '6D648081-F93C-4CE9-9C2F-AE7F234C3BE0'
    ) {
      pathString =
        'M 135.718 274.892 L 139.752 288.787 L 145.579 296.854 L 153.198 302.233 L 183.676 338.089 L 232.979 382.91 L 269.284 409.354 L 287.66 419.663 L 295.728 428.627 L 312.76 460.897 L 359.373 425.041 L 351.305 417.87 L 349.064 411.595 L 353.098 392.322 L 338.307 389.633 L 324.861 390.978 L 321.276 388.288 L 300.658 368.567 L 277.351 343.916 L 239.254 295.51 L 228.497 281.616 L 210.12 265.928 L 202.053 261.895 L 196.674 255.171 L 126.306 260.102 L 135.718 274.892 Z';
    }

    // Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'CBD8567A-DF77-4D02-AB9B-A678E7168239'
    ) {
      pathString =
        'M 236.116 252.482 L 306.036 257.412 L 298.417 269.066 L 296.176 273.996 L 292.59 286.098 L 285.867 295.51 L 280.489 299.095 L 273.317 306.267 L 248.666 334.952 L 220.877 361.396 L 198.019 379.324 L 180.539 393.667 L 163.507 405.768 L 150.061 413.388 L 143.338 419.214 L 137.959 424.145 L 124.961 450.589 L 120.031 457.76 L 81.934 426.834 L 84.623 409.354 L 77.9 392.322 L 83.278 388.736 L 92.69 386.944 L 107.929 386.495 L 118.238 379.772 L 155.887 339.434 L 194.881 291.924 L 202.949 281.616 L 211.465 272.203 L 220.429 265.032 L 226.256 260.998 L 236.116 252.482 Z';
    }

    // Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '327C5072-BBD3-4B4D-AB2B-DC8B4453E0DB'
    ) {
      pathString =
        'M 96.724 157.463 L 175.16 142.672 L 184.124 180.321 L 187.262 200.939 L 191.744 233.658 L 193.537 245.759 L 197.571 256.068 L 204.742 263.687 L 211.017 266.377 C 211.775 265.872 240.514 292.876 237.909 294.613 L 277.351 343.916 C 277.042 344.843 322.235 392.132 323.068 389.633 L 333.377 389.185 L 345.03 390.529 L 354.891 393.667 L 346.823 411.595 L 359.821 426.834 L 312.76 460.449 L 292.59 424.145 L 271.076 409.802 L 233.875 382.462 L 184.573 338.089 C 185.591 338.428 151.602 301.253 149.164 300.44 L 141.097 289.235 L 137.063 282.96 L 136.166 275.789 L 120.031 249.345 L 109.274 223.797 L 101.206 192.423 L 96.724 157.463 Z';
    }

    // Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'FCB0220B-2A63-40DE-93CE-38C70BA2E576'
    ) {
      pathString =
        'M 258.527 139.086 L 336.066 153.877 L 332.929 182.114 L 329.791 197.801 L 323.517 220.211 L 316.793 238.588 L 304.244 260.102 L 297.072 270.859 L 293.935 283.857 L 286.315 295.062 L 280.041 299.544 L 249.563 333.159 L 200.26 379.324 L 168.885 402.183 L 147.82 414.732 L 141.545 419.663 L 125.41 449.244 L 120.927 458.208 L 103.447 455.071 L 72.521 423.696 L 84.623 411.595 L 84.175 407.561 L 83.278 388.288 L 107.481 386.495 L 120.479 377.531 L 140.2 356.466 L 156.784 338.089 L 196.674 289.235 L 204.294 279.374 L 215.051 269.514 L 224.911 261.446 L 232.979 255.62 L 238.357 249.345 L 241.495 235.45 L 246.425 196.457 L 251.355 166.427 L 258.527 139.086 Z';
    }

    // Lower Inside Left
    if (
      image?.imageIdentity?.toUpperCase() ==
      '99EE49DB-DD24-44EA-B301-FB3BFC1853E8'
    ) {
      pathString =
        'M 322.264 388.338 L 277.384 344.704 L 236.244 291.721 L 193.857 253.074 L 137.134 292.344 L 184.507 337.224 L 234.997 383.351 L 292.968 422.621';
    }

    // Lower Inside Right
    if (
      image?.imageIdentity?.toUpperCase() ==
      'DA9F35DE-D2FB-4482-AD3B-96D77E16172F'
    ) {
      pathString =
        'M 258.527 139.086 L 336.066 153.877 L 332.929 182.114 L 329.791 197.801 L 323.517 220.211 L 316.793 238.588 L 304.244 260.102 L 297.072 270.859 L 293.935 283.857 L 286.315 295.062 L 280.041 299.544 L 249.563 333.159 L 200.26 379.324 L 168.885 402.183 L 147.82 414.732 L 141.545 419.663 L 110.17 385.15 L 120.479 377.531 L 140.2 356.466 L 156.784 338.089 L 196.674 289.235 L 204.294 279.374 L 215.051 269.514 L 224.911 261.446 L 232.979 255.62 L 238.357 249.345 L 241.495 235.45 L 246.425 196.457 L 251.355 166.427 L 258.527 139.086 Z';
    }

    // Body Part Frontside
    if (
      image?.imageIdentity?.toUpperCase() ==
      'A6F7949D-1526-4EF7-9CCA-6BB03DD6C20C'
    ) {
      pathString =
        'M204.3,26.4h-110.7l-1,1.9s-.3,7.5-6.3,25.9c-6,18.4-7.7,29.7-10.3,41.8-2.6,12.1-3,43.4-3,58.8s2.4,24.1,2.6,26.4l60.4-1.1c1.4-6,2.5-11.3,4-18.5,5.8-28.9,9-37.9,9-37.9v.4c0,0,2.2,9.1,8,37.9,1.1,5.6,2.2,9,3.3,13.8l61.8-1.3c1-8.9,1.8-14,1.8-19.4,0-15.4-.4-46.7-3-58.8-2.6-12.1-4.3-23.4-10.3-41.8-6-18.4-6.3-27-6.3-27v-1.1Z';
    }

    // Body Part Backside
    if (
      image?.imageIdentity?.toUpperCase() ==
      'B802DE13-E36B-4E63-B611-737ECE759990'
    ) {
      pathString =
        'M204.3,26.4h-110.7l-1,1.9s-.3,7.5-6.3,25.9c-6,18.4-7.7,29.7-10.3,41.8-2.6,12.1-3,43.4-3,58.8s2.4,24.1,2.6,26.4l60.4-1.1c1.4-6,2.5-11.3,4-18.5,5.8-28.9,9-37.9,9-37.9v.4c0,0,2.2,9.1,8,37.9,1.1,5.6,2.2,9,3.3,13.8l61.8-1.3c1-8.9,1.8-14,1.8-19.4,0-15.4-.4-46.7-3-58.8-2.6-12.1-4.3-23.4-10.3-41.8-6-18.4-6.3-27-6.3-27v-1.1Z';
    }

    //New 2025-06-04
    // Right Lower Arm Outside
    if (
      image?.imageIdentity?.toUpperCase() ==
      '381F4F2A-F64F-4C1E-A192-29DB0A83BCB5'
    ) {
      pathString =
        'M 140.422 288.45 C 134.797 301.576 289.486 433.866 293.131 424.777 C 293.349 424.234 321.215 389.671 321.215 389.671 C 321.781 389.247 205.687 251.935 197.761 255.685 C 195.117 256.936 141.007 287.28 140.422 288.45 Z';
    }

    // Left Lower Arm Outside
    if (
      image?.imageIdentity?.toUpperCase() ==
      'D831324A-21B0-426F-A0E3-449316CF92E8'
    ) {
      pathString =
        'M 211.218 253.345 L 197.761 261.536 C 195.024 257.431 83.011 385.467 84.253 386.746 C 85.495 388.025 105.545 417.835 115.848 421.266 C 126.151 424.697 271.906 296.721 266.802 287.28 C 261.698 277.839 214.144 252.76 211.218 253.345 Z';
    }

    // Right Lower Arm Inside
    if (
      image?.imageIdentity?.toUpperCase() ==
      'E8357E6D-BFD9-4780-B791-E3089EBE9B96'
    ) {
      pathString =
        'M 93.03 290.207 L 93.029 290.206 L 94.785 291.376 L 92.444 290.206 L 133.401 337.598 C 131.716 344.339 239.627 428.744 241.643 423.021 C 243.659 417.298 271.483 389.086 270.897 389.086 C 270.311 389.086 227.016 344.619 227.016 344.619 L 186.059 293.131 C 187.936 292.192 158.602 262.685 155.634 263.291 C 152.666 263.897 146.273 252.175 146.273 252.175 L 145.102 250.419';
    }

    // Left Lower Arm Inside
    if (
      image?.imageIdentity?.toUpperCase() ==
      '5368838F-4D24-4FA1-8CC3-04B1EA3160E6'
    ) {
      pathString =
        'M 82.498 387.331 L 85.423 383.82 C 93.833 369.594 203.524 246.028 210.048 253.345 C 210.048 253.345 263.494 281.047 266.802 287.865 C 270.11 294.683 121.794 431.892 113.508 422.436 C 105.222 412.98 81.328 388.501 82.498 387.331 Z';
    }

    // Right Hand Arm Outside
    if (
      image?.imageIdentity?.toUpperCase() ==
      '6E0A0A29-33C2-4651-8F04-ADF393C13B41'
    ) {
      pathString =
        'M 47.978 156.805 C 47.978 156.805 61.435 222.92 61.435 225.26 C 61.435 227.6 87.764 272.653 87.764 272.653 L 93.03 288.45 L 150.954 353.981 L 242.813 424.192 L 265.047 461.052 L 281.429 456.957 L 295.471 453.446 L 306.588 441.744 L 301.322 413.075 L 291.376 389.671 L 277.919 390.256 L 264.461 384.405 L 190.74 294.886 C 190.74 294.886 159.145 266.802 156.805 262.706 C 154.465 258.61 145.103 244.568 145.103 244.568 L 125.795 139.837 L 47.978 156.805 Z';
    }

    // Left Hand Arm Outside
    if (
      image?.imageIdentity?.toUpperCase() ==
      '42BE4374-08B7-49C6-9468-902DC910C13E'
    ) {
      pathString =
        'M 307.173 155.049 L 294.301 221.75 C 294.301 221.75 275.578 259.781 274.993 260.951 C 274.408 262.121 264.461 284.94 264.461 284.94 L 197.761 355.736 C 197.761 355.736 150.954 394.937 151.539 394.937 C 152.124 394.937 109.997 421.266 109.997 421.266 L 88.934 461.052 L 76.062 455.201 C 76.062 455.201 66.115 459.297 60.85 448.765 C 55.585 438.233 49.733 437.649 49.733 437.649 L 38.031 428.872 C 38.031 428.872 57.924 411.905 57.924 410.734 C 57.924 409.563 62.02 386.161 62.02 386.161 L 74.892 385.575 C 74.892 385.575 105.317 356.906 106.487 356.321 C 107.657 355.736 163.826 294.301 163.826 294.301 L 194.836 261.536 C 194.836 261.536 209.463 250.419 209.463 249.834 C 209.463 249.249 227.601 139.837 227.601 139.837 L 307.173 155.049 Z';
    }

    // Right Hand Arm Outside Bolero
    if (
      image?.imageIdentity?.toUpperCase() ==
      '16349435-0D31-4E3B-8753-B1B6A698188C'
    ) {
      pathString =
        'M 46.222 138.667 L 97.71 56.169 C 107.416 56.169 153.663 255.685 146.273 255.685 C 156.639 247.911 272.181 389.148 271.483 389.671 L 296.056 390.841 L 296.642 411.905 L 303.078 434.723 L 263.876 462.808 L 239.888 418.926 C 231.826 426.988 77.176 299.038 87.764 288.45 C 85.992 288.45 43.734 187.229 47.978 187.229 L 46.222 138.667 Z';
    }

    // Left Hand Arm Outside Bolero
    if (
      image?.imageIdentity?.toUpperCase() ==
      'C2AC0348-01E8-402E-9A75-7E521C587E6A'
    ) {
      pathString =
        'M 309.514 138.667 L 260.951 49.733 C 254.4 43.182 204.612 248.494 208.878 252.76 C 207.648 242.917 84.668 384.798 83.668 386.161 C 82.668 387.524 50.318 389.086 50.318 390.256 C 50.318 391.426 60.264 408.394 60.264 410.734 C 60.264 413.074 54.414 425.947 56.169 431.213 C 57.924 436.479 91.859 458.712 92.444 458.712 C 93.029 458.712 113.508 418.341 113.508 418.341 C 118.87 420.639 226.724 339.395 221.165 337.013 C 251.853 324.198 346.601 150.812 309.514 138.667 Z';
    }

    // Right Hand Arm Inside
    if (
      image?.imageIdentity?.toUpperCase() ==
      'B51846C3-33FC-4785-85EE-F03ED9B3599C'
    ) {
      pathString =
        'M 49.148 157.39 L 60.85 222.335 L 94.2 289.035 L 136.326 337.598 L 186.644 383.82 C 186.644 383.82 245.739 423.606 245.739 424.777 C 245.739 425.948 265.047 458.712 265.047 458.712 L 302.492 413.075 C 302.492 413.075 290.791 390.256 290.206 390.256 C 289.621 390.256 276.163 390.841 276.163 391.426 C 276.163 392.011 204.782 314.194 204.782 314.194 L 191.325 295.471 L 159.73 263.876 L 148.028 251.589 L 138.082 184.304 C 138.082 184.304 128.72 142.177 126.965 142.177 C 125.21 142.177 50.318 157.39 49.148 157.39 Z';
    }

    // Left Hand Arm Inside
    if (
      image?.imageIdentity?.toUpperCase() ==
      '61BC15DC-B2B7-471B-94BC-B1B4B98EDA56'
    ) {
      pathString =
        'M 310.099 156.805 C 310.099 156.805 299.567 222.92 298.982 222.92 C 298.397 222.92 272.653 273.823 272.653 273.823 L 267.387 288.45 C 267.387 288.45 223.505 334.087 222.92 334.672 C 222.335 335.257 174.357 380.895 174.357 380.895 L 115.263 422.436 C 115.263 422.436 97.125 464.563 93.615 461.637 C 90.105 458.711 59.679 410.734 59.094 409.564 C 58.509 408.394 68.456 389.086 68.456 389.086 L 81.328 386.161 L 155.049 313.609 C 155.049 313.609 176.698 279.674 177.283 279.674 C 177.868 279.674 204.197 258.611 204.197 258.611 L 215.899 235.207 L 232.281 138.667 L 310.099 156.805 Z';
    }

    // Right Hand Arm Inside Bolero
    if (
      image?.imageIdentity?.toUpperCase() ==
      'EC443C60-BB09-4FAD-95E5-F5E602308EA8'
    ) {
      pathString =
        'M 47.392 139.837 L 47.392 137.497 L 91.859 49.733 C 112.308 50.663 152.05 267.945 147.443 256.855 C 142.836 245.765 273.37 389.232 272.653 390.256 L 294.301 390.256 L 297.811 413.66 L 303.078 433.553 C 303.078 433.553 266.802 463.978 265.047 463.393 C 263.292 462.808 235.207 419.511 235.207 419.511 C 227.406 426.532 82.888 295.471 90.689 288.45 C 85.123 305.148 36.211 173.38 47.392 139.837 Z';
    }

    // Left Hand Arm Inside Bolero
    if (
      image?.imageIdentity?.toUpperCase() ==
      '543D2923-FD29-4E97-9181-7A7372F8F761'
    ) {
      pathString =
        'M 308.928 138.082 L 307.758 135.156 L 258.025 54.414 C 246.207 56.563 205.396 254.776 210.048 253.93 C 201.837 251.193 83.453 387.844 83.668 387.916 L 54.999 389.671 L 58.509 411.32 L 54.999 434.138 C 47.314 434.138 87.285 462.222 93.615 460.467 C 99.945 458.712 119.944 415.415 119.944 415.415 C 128.319 420.3 275.938 295.632 265.632 289.62 C 274.956 292.106 325.74 144.71 311.854 141.007';
    }

    // Right Arm Outside
    if (
      image?.imageIdentity?.toUpperCase() ==
      '7334CB4D-D316-474D-9A32-404C0B6B7B78'
    ) {
      pathString =
        'M 47.978 153.294 C 36.4 159.083 84.39 289.552 91.274 286.11 C 83.796 293.588 235.677 427.232 243.398 420.096 C 251.119 412.96 272.068 384.405 272.068 384.405 C 272.377 384.328 160.273 255.549 155.049 256.855 C 155.049 256.855 125.795 138.667 125.21 138.667 C 124.625 138.667 49.148 152.709 47.978 153.294 Z';
    }

    // Left Arm Outside
    if (
      image?.imageIdentity?.toUpperCase() ==
      '576C8047-079B-4B5B-ABC0-345D74304B8A'
    ) {
      pathString =
        'M 232.281 137.497 L 231.111 150.369 C 223.404 148.442 216.732 260.314 211.218 253.93 C 205.704 247.546 83.143 382.245 84.253 383.82 C 85.363 385.395 111.76 419.512 116.433 419.511 C 121.106 419.51 226.306 333.139 224.675 332.332 C 223.044 331.525 274.78 275.817 271.483 274.993 C 273.595 276.049 312.928 185.719 308.928 183.719 L 308.928 153.879 L 232.281 137.497 Z';
    }

    // Right Arm Outside Bolero
    if (
      image?.imageIdentity?.toUpperCase() ==
      '14B2E6B6-737C-43E3-9AE2-1B2FD85BBA3D'
    ) {
      pathString =
        'M 47.978 139.837 L 52.073 122.869 L 95.37 55.584 C 95.37 55.584 111.753 82.498 111.167 83.083 C 110.581 83.668 126.38 147.443 126.38 147.443 L 145.688 255.685 L 181.964 284.94 L 272.068 389.671 L 241.643 422.436 L 173.772 376.799 L 132.816 338.768 L 91.274 290.791 L 85.423 272.068 L 66.115 245.739 L 59.679 224.675 L 47.978 170.262 L 47.978 139.837 Z';
    }

    // Left Arm Outside Bolero
    if (
      image?.imageIdentity?.toUpperCase() ==
      'EDD6FBB6-7778-4DBB-B17F-6BC656254414'
    ) {
      pathString =
        'M 311.854 137.497 L 307.758 124.039 L 265.047 48.563 L 248.664 71.966 L 246.324 102.391 L 232.281 145.103 L 212.973 252.175 C 212.973 252.175 203.694 266.884 198.346 263.876 C 192.998 260.868 87.101 384.912 87.179 384.99 L 117.018 420.096 L 173.772 379.725 L 225.845 335.258 L 267.387 287.28 C 267.387 287.28 276.163 266.217 276.748 266.217 C 277.333 266.217 299.567 218.239 299.567 218.239 C 304.72 219.957 316.042 138.893 311.854 137.497 Z';
    }

    // Right Arm Inside
    if (
      image?.imageIdentity?.toUpperCase() ==
      '2828667E-D79F-485F-A732-95B55E26D26A'
    ) {
      pathString =
        'M 239.888 425.362 L 232.867 421.851 C 229.703 428.336 96.997 301.386 90.104 290.206 C 83.211 279.026 32.782 165.425 45.637 157.39 C 45.637 157.39 124.625 135.741 124.625 141.007 C 124.625 146.273 151.844 275.858 158.56 269.142 C 165.276 262.426 273.248 388.491 271.483 390.256 C 269.718 392.021 242.813 424.777 239.888 425.362 Z';
    }

    // Left Arm Inside
    if (
      image?.imageIdentity?.toUpperCase() ==
      '6F91E6CC-23B3-4B90-9062-4CCEFE16B862'
    ) {
      pathString =
        'M 236.377 140.422 L 232.281 155.634 C 227.557 153.88 219.275 259.71 215.899 253.93 C 212.523 248.15 88.152 382.007 88.349 384.99 C 88.546 387.973 100.384 422.925 119.359 421.851 C 138.334 420.777 296.837 280.548 273.238 279.674 C 279.097 282.278 324.056 160.408 314.194 156.805 C 304.332 153.202 236.962 141.592 236.377 140.422 Z';
    }

    // Right Arm Inside Bolero
    if (
      image?.imageIdentity?.toUpperCase() ==
      '2EFE3334-72FD-4DAB-B895-BB31CE48D428'
    ) {
      pathString =
        'M 45.052 139.837 L 45.637 137.497 L 87.764 45.052 C 107.504 48.752 150.08 256.983 144.518 256.27 C 153.702 251.022 271.989 388.212 270.312 389.086 C 268.635 389.96 242.824 413.618 239.888 423.021 C 236.952 432.424 83.95 303.708 87.764 288.45 L 53.243 215.314';
    }

    // Left Arm Inside Bolero
    if (
      image?.imageIdentity?.toUpperCase() ==
      'D128BE2D-E896-4EAF-8602-18AABDB6FA23'
    ) {
      pathString =
        'M 307.173 138.082 L 304.248 128.72 L 260.951 47.392 C 250.223 41.432 226.098 143.358 228.186 144.518 C 222.685 152.22 209.877 267.709 206.537 255.685 C 203.197 243.661 81.63 385.596 81.913 386.746 C 82.053 387.314 96.54 404.298 101.806 410.149 C 107.072 416 111.167 422.436 111.167 422.436 C 122.356 418.706 237.244 327.362 220.58 332.917 C 220.58 332.917 258.025 295.471 260.366 291.961 C 262.707 288.451 294.886 222.92 294.886 222.92 C 296.678 223.517 310.01 139.028 307.173 138.082 Z';
    }

    // Left Palm and Lower Arm
    if (
      image?.imageIdentity?.toUpperCase() ==
      '956DA65F-E9E1-4A98-9AF8-734419A9D64E'
    ) {
      pathString =
        'M 58.957 286.543 L 64.028 285.275 C 64.028 285.275 97.628 258.016 97.628 257.382 C 97.628 256.748 112.208 200.327 114.11 199.693 C 116.012 199.059 155.95 187.648 155.95 187.648 L 207.3 185.746 C 207.3 185.746 249.14 192.719 249.774 193.987 C 250.408 195.255 288.445 240.899 288.445 240.899 C 294.944 242.524 254.338 394.416 254.846 392.412 C 255.354 390.408 275.407 519.304 271.328 520.469 L 110.94 521.737 C 108.281 519.078 117.534 426.265 117.914 426.645 L 128.057 398.751 C 124.403 399.969 51.357 292.458 57.689 290.347';
    }

    // Top of Hand and Lower Arm
    if (
      image?.imageIdentity?.toUpperCase() ==
      'F2561F73-0448-4FAE-AE6D-090C248D788D'
    ) {
      pathString =
        'M 266.802 293.131 C 273.155 295.513 179.315 389.044 173.187 386.746 C 173.187 386.746 117.603 425.947 116.433 426.532 C 115.263 427.117 93.03 469.829 92.444 469.244 C 91.858 468.659 79.572 459.882 79.572 459.882 L 64.945 456.372 L 55.584 445.84 C 55.584 445.84 42.127 433.553 45.637 432.968 C 49.147 432.383 61.435 418.341 60.85 417.756 C 60.265 417.171 56.169 396.107 56.169 396.107 L 81.913 393.767 L 130.475 347.545 L 170.847 297.812 C 168.847 292.811 211.332 258.311 212.388 260.951 L 266.802 293.131 Z';
    }

    // Top of Hand and Lower Arm
    if (
      image?.imageIdentity?.toUpperCase() ==
      '05834B67-0DB8-417C-A04E-9FE496B05B8D'
    ) {
      pathString =
        'M 267.387 286.695 L 174.357 379.139 L 112.923 421.851 C 112.923 421.851 91.859 464.563 89.519 462.808 C 87.179 461.053 76.062 454.031 76.062 454.031 L 62.605 449.35 L 51.488 438.819 L 59.094 409.564 L 52.073 391.426 L 77.817 383.235 L 93.03 375.629 L 129.305 339.938 L 167.336 291.376 L 208.878 250.419 L 267.387 286.695 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'E10A379B-129D-4414-A16A-B845E15414CB'
    ) {
      pathString =
        'M 37.71 274.447 L 40.853 232.546 L 31.425 194.312 C 31.425 194.312 18.331 149.27 18.331 148.746 C 18.331 148.222 6.809 97.942 6.809 97.942 L 4.19 53.947 L 4.19 7.333 L 64.945 8.904 C 64.945 8.904 76.992 53.423 76.992 53.947 C 76.992 54.471 86.419 111.559 86.419 111.559 L 84.324 148.746 C 84.324 148.746 79.087 205.835 79.087 206.359 C 79.087 206.883 79.087 224.69 79.087 224.69 C 79.087 224.69 79.61 236.736 79.61 237.26 C 79.61 237.784 83.8 276.542 83.8 276.542 L 37.71 274.447 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '16494783-4171-4E9B-9450-07C8E713D383'
    ) {
      pathString =
        'M 123.082 274.97 L 123.606 261.353 L 119.939 243.545 L 123.082 222.595 L 140.89 148.746 L 157.126 77.515 C 157.126 77.515 155.555 45.567 156.078 45.567 C 156.601 45.567 156.602 8.904 156.602 8.904 L 95.323 10.475 L 85.372 53.947 L 78.039 91.133 L 76.992 150.317 L 82.229 222.595 L 81.182 238.308 L 79.61 274.97 L 123.082 274.97 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '283862BD-658F-40C8-9875-7D7A81E9B8DC'
    ) {
      pathString =
        'M 31.949 254.544 L 30.378 255.068 L 36.139 221.024 L 26.711 196.931 C 26.711 196.931 26.711 156.078 26.711 155.031 C 26.711 153.984 21.998 127.272 21.998 127.272 C 21.998 127.272 9.951 64.945 9.951 64.422 C 9.951 63.899 7.856 45.567 7.856 45.567 L 9.428 7.333 L 91.133 9.428 L 91.657 64.422 L 83.277 127.796 L 71.754 172.315 L 75.42 194.836 L 81.182 228.356 L 83.8 256.115';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'A5B9F4D6-F13E-4A31-99B4-132049FFF5CE'
    ) {
      pathString =
        'M 68.29 255.677 L 68.29 253.492 L 73.753 194.489 L 73.753 175.368 L 60.095 75.938 C 60.095 75.938 59.002 32.233 58.456 31.14 C 57.91 30.047 61.734 7.648 61.734 7.648 C 61.734 7.648 138.765 8.741 139.857 8.741 C 140.949 8.741 143.135 48.622 143.135 48.622 L 131.116 126.746 L 124.561 195.582 C 124.561 195.582 116.912 226.722 116.912 227.268 C 116.912 227.814 114.181 254.038 114.181 254.038';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '315BF1D4-59AA-4BC1-902F-7080E8BC1C22'
    ) {
      pathString =
        'M 123.082 274.97 L 123.606 270.257 L 119.416 242.498 L 123.082 223.643 C 123.082 223.643 142.461 149.27 142.985 148.746 C 143.509 148.222 156.602 90.086 156.602 90.086 L 155.555 47.138 L 156.602 9.428 L 95.323 9.951 L 85.372 54.994 L 76.992 98.466 L 78.039 147.698 L 82.229 221.024 L 81.182 256.639 L 79.61 276.542 L 123.082 274.97 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      'FA107AD9-E88B-4A0B-8708-29B8E927B871'
    ) {
      pathString =
        'M 39.805 277.589 C 39.805 277.589 41.9 257.163 41.9 255.591 C 41.9 254.019 39.805 222.595 39.805 222.595 L 19.379 147.175 C 19.379 147.175 5.761 92.704 5.761 91.657 C 5.761 90.61 4.714 52.899 4.714 52.899 L 6.809 7.856 L 65.993 9.428 L 76.468 54.994 C 76.468 54.994 85.372 104.227 85.372 104.751 C 85.372 105.275 85.372 149.793 85.372 149.793 L 80.134 200.597 C 80.134 200.597 80.658 215.786 81.182 215.786 C 81.706 215.786 80.134 233.07 80.134 233.07 L 79.61 252.973 C 79.61 252.973 83.8 274.97 83.277 275.494 C 82.754 276.018 40.853 277.589 39.805 277.589 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '02D1B1D4-C1B3-4093-BA87-B95B4F0BC60F'
    ) {
      pathString =
        'M 81.064 257.045 L 76.96 221.644 L 74.394 195.991 L 84.143 124.675 L 90.812 60.542 L 87.221 9.748 L 9.235 10.261 L 4.105 50.28 C 4.105 50.28 18.983 128.266 18.983 131.857 C 18.983 135.448 23.088 194.451 23.601 194.964 C 24.114 195.477 33.349 224.209 33.862 224.209 C 34.375 224.209 34.888 254.993 34.888 256.019 C 34.888 257.045 82.09 256.532 81.064 257.045 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '0E1DBCB6-F551-4193-A522-2F34D49130F7'
    ) {
      pathString =
        'M 117.321 255.591 L 114.178 223.119 L 122.034 197.979 L 127.272 126.748 L 140.89 46.614 C 140.89 46.614 143.508 8.904 142.461 8.904 C 141.414 8.904 59.708 9.428 59.708 9.428 L 57.613 62.327 C 57.613 62.327 67.564 126.224 67.04 126.224 C 66.516 126.224 76.468 167.601 76.992 167.601 C 77.516 167.601 74.373 195.36 74.373 195.36 L 70.707 223.643 C 70.707 223.643 66.517 254.544 66.517 255.068 C 66.517 255.592 115.749 255.591 117.321 255.591 Z';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '2325B555-220E-4A87-BA4F-C1EA9D67919E'
    ) {
      pathString =
        'M 13.002 305.751 L 14.972 305.751 C 14.972 305.751 111.111 308.115 111.111 305.751 C 111.111 303.387 99.684 249.014 99.684 249.014 L 102.836 234.829 L 100.078 221.039 L 130.023 113.081 C 131.568 109.99 120.014 87 117.415 92.198 L 107.171 81.56 L 26.793 80.772 L 21.276 96.532 L 23.247 115.445 L 24.429 130.417 C 24.429 130.417 27.581 144.207 27.581 144.601 C 27.581 144.995 30.733 169.03 30.733 169.03 L 22.853 225.767 L 15.76 241.922 L 16.154 263.986';
    }

    if (
      image?.imageIdentity?.toUpperCase() ==
      '379EF548-B520-477C-BFA6-9721C50F7C5D'
    ) {
      pathString =
        'M 93.723 287.375 L 148.964 256.962 C 154.438 255.867 194.981 292.448 192.411 292.962 L 233.376 347.582 L 273.72 389.788 C 273.72 389.788 298.548 390.409 298.548 391.029 C 298.548 391.649 258.203 449.373 258.203 449.373 L 235.238 416.477 L 172.549 371.788 L 137.171 336.409 L 93.723 287.375 Z';
    }

    if (image?.imageUrl) {
      let imageUrl = '';

      if (attribute.imageUrl && !this.attributeModified[attribute.guid]) {
        imageUrl = attribute.imageUrl;
      } else {
        imageUrl = image?.imageUrl;
      }

      this.http.get(imageUrl, { responseType: 'text' }).subscribe(
        (svgContent: string) => {
          // Sanitize and store the SVG content

          const prefix = `svg-${attribute.guid}`;
          const inlinedSvg = this.inlineSvgStyles(svgContent, prefix);
          this.svgContent[attribute.guid] =
            this.sanitizer.bypassSecurityTrustHtml(inlinedSvg);

          // Wait for the content to be rendered and manipulate it
          setTimeout(() => {
            // Select all SVG containers on the page
            const svgContainers = document.querySelectorAll(`.svg-container`);
            svgContainers.forEach((svgContainer) => {
              const svgElement = svgContainer.querySelector('svg');
              if (svgElement) {
                const snapSvg = Snap(svgElement);
                let snapRect = snapSvg.rect();

                // Set up an event listener on each SVG for the onClick behavior
                svgElement.addEventListener('click', (event) => {
                  const allElements = svgElement.querySelectorAll('*');

                  allElements.forEach((element) => {
                    const fill = element.getAttribute('fill');
                    const stroke = element.getAttribute('stroke');

                    if (
                      (fill && this.isRed(fill)) ||
                      (stroke && this.isRed(stroke))
                    ) {
                      element.remove();
                    }
                  });

                  const pt = svgElement.createSVGPoint();
                  pt.x = event.clientX;
                  pt.y = event.clientY;
                  const ctm = svgElement.getScreenCTM();
                  if (!ctm) {
                    console.warn('SVG getScreenCTM() returned null.');
                    return;
                  }
                  const svgP = pt.matrixTransform(ctm.inverse());
                  const mouseX = svgP.x;
                  const mouseY = svgP.y;

                  // Remove the previous rectangle if it exists
                  snapRect = snapRect.remove();

                  // Check if the click is inside the restricted zone
                  const isInside = Snap.path.isPointInside(
                    pathString,
                    mouseX,
                    mouseY,
                  );
                  if (isInside) {
                    snapRect = snapSvg
                      .rect(mouseX, mouseY, 9, 9)
                      .attr({ fill: 'red' });
                    this.showInvalidPositionMessage[attribute.guid] = false; // Show the message

                    const selectedImage = this.selectedImages.find(
                      (img) => img.guid === attribute.guid,
                    );
                    if (selectedImage) {
                      const aux = new XMLSerializer().serializeToString(
                        svgElement,
                      );

                      const buff = Buffer.from(aux);
                      const base64data = buff.toString('base64');
                      selectedImage.imageUrl = base64data;
                    }
                    this.showInvalidPositionMessage[attribute.guid] = false; // Show the message
                  } else {
                    this.showInvalidPositionMessage[attribute.guid] = true; // Show the message
                  }
                });
              }
            });
          }, 0); // Ensure SVG is fully loaded before adding the listener
        },
        (error) => {
          console.error(`Failed to load SVG for ${attribute.guid}:`, error);
          // Set a fallback SVG if loading fails
          this.svgContent[attribute.guid] =
            this.sanitizer.bypassSecurityTrustHtml(this.getEmptySvg());
        },
      );
    } else {
      // No image URL provided, set a fallback SVG
      this.svgContent[attribute.guid] = this.sanitizer.bypassSecurityTrustHtml(
        this.getEmptySvg(),
      );
    }
  }

  private isRed(color: string): boolean {
    color = color.toLowerCase();

    // Nome
    if (color === 'red') return true;

    // Hex
    if (color.match(/^#(f{2}0{4}|[aA-f]{1}0{2})$/)) return true;

    // RGB
    const rgbMatch = color.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
    if (rgbMatch) {
      const r = parseInt(rgbMatch[1]);
      const g = parseInt(rgbMatch[2]);
      const b = parseInt(rgbMatch[3]);
      return r > 200 && g < 50 && b < 50;
    }

    return false;
  }

  /**
   * Handles the blur event on measurement inputs.
   * Resets the SVG fill color.
   * @param measureName The name of the measurement.
   * @param attributeOptionId The ID of the MeasurementContainer.
   */
  onBlur(measureName: string, attributeOptionId: number): void {
    this.resetSvgFill(measureName, attributeOptionId);
  }

  /**
   * Changes the fill color of a specific SVG element.
   * @param measureName The name of the measurement corresponding to the SVG element's class.
   * @param color The desired fill color.
   * @param attributeOptionId The ID of the MeasurementContainer.
   */
  changeSvgFill(
    measureName: string,
    color: string,
    attributeOptionId: number,
  ): void {
    const svgContainerId = `svg-container-${attributeOptionId}`;
    const svgContainer = document.getElementById(svgContainerId);

    if (!svgContainer) {
      console.warn(`SVG container with ID ${svgContainerId} not found.`);
      return;
    }

    const classToUse = measureName
      .split('(')[0] // get part before parentheses
      .toLowerCase()
      .replace(/[^a-z0-9]/g, ''); // clean for class

    const prefix = `svg-${attributeOptionId}`;
    const svgClass = `${prefix}-${classToUse}`;
    const svgElements = svgContainer.querySelectorAll(`.${svgClass}`);

    if (svgElements.length) {
      svgElements.forEach((el) => {
        this.renderer.setStyle(el, 'stroke-width', '3');
        this.renderer.setStyle(el, 'stroke', color);
        this.renderer.setStyle(el, 'opacity', '1');
      });
    } else {
      console.warn(
        `SVG elements with class ${svgClass} not found in container ${svgContainerId}.`,
      );
    }
  }

  inlineSvgStyles(svg: string, prefix: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(svg, 'image/svg+xml');

    // Inline <style> rules as element styles
    const styleTag = doc.querySelector('style');
    if (styleTag) {
      const css = styleTag.textContent || '';
      const rules = css.match(/[^{]+\{[^}]*\}/g);

      rules?.forEach((rule) => {
        const [selectorRaw, styleRaw] = rule.split('{');
        const selector = selectorRaw.trim();
        const style = styleRaw.replace('}', '').trim();

        try {
          const elements = doc.querySelectorAll(selector);
          elements.forEach((el) => {
            const existingStyle = el.getAttribute('style') || '';
            el.setAttribute('style', `${existingStyle}; ${style}`);
          });
        } catch (error) {
          console.warn(`Invalid selector skipped: ${selector}`);
        }
      });

      styleTag.remove();
    }

    // Prefix IDs
    const idMap = new Map<string, string>();
    const elementsWithId = doc.querySelectorAll('[id]');
    elementsWithId.forEach((el) => {
      const oldId = el.id;
      const newId = `${prefix}-${oldId}`;
      idMap.set(oldId, newId);
      el.id = newId;
    });

    // Prefix classes
    const elementsWithClass = doc.querySelectorAll('[class]');
    elementsWithClass.forEach((el) => {
      const oldClasses = (el.getAttribute('class') || '').split(' ');
      const newClasses = oldClasses
        .filter((cls) => cls.trim().length > 0)
        .map((cls) => `${prefix}-${cls}`)
        .join(' ');
      el.setAttribute('class', newClasses);
    });

    // Update references to IDs and classes in attributes and styles
    const elements = doc.querySelectorAll('*');
    elements.forEach((el) => {
      for (const attr of el.getAttributeNames()) {
        const value = el.getAttribute(attr);
        if (!value) continue;

        // Update url(#id) references
        const updatedValue = value.replace(/url\(#([^)]+)\)/g, (match, id) => {
          return idMap.has(id) ? `url(#${idMap.get(id)})` : match;
        });

        if (updatedValue !== value) {
          el.setAttribute(attr, updatedValue);
        }
      }

      // Update url(#id) in inline styles
      const style = el.getAttribute('style');
      if (style) {
        const updatedStyle = style.replace(/url\(#([^)]+)\)/g, (match, id) => {
          return idMap.has(id) ? `url(#${idMap.get(id)})` : match;
        });

        if (updatedStyle !== style) {
          el.setAttribute('style', updatedStyle);
        }
      }
    });

    return doc.documentElement.outerHTML;
  }

  fetchSvg(measurementContainer: MeasurementContainer): void {
    if (!measurementContainer?.imageUrl) {
      this.svgContent[measurementContainer.attributeOptionId] =
        this.sanitizer.bypassSecurityTrustHtml(this.getEmptySvg());

      return;
    }

    this.http
      .get(measurementContainer.imageUrl, { responseType: 'text' })
      .subscribe(
        (svg: string) => {
          const prefix = `svg-${measurementContainer.attributeOptionId}`;
          const inlinedSvg = this.inlineSvgStyles(svg, prefix);
          this.svgContent[measurementContainer.attributeOptionId] =
            this.sanitizer.bypassSecurityTrustHtml(inlinedSvg);
        },
        (error) => {
          console.error(
            `Error fetching SVG from ${measurementContainer.imageUrl}:`,
            error,
          );
        },
      );
  }

  /**
   * Resets the fill color of a specific SVG element to its original color.
   * @param measureName The name of the measurement corresponding to the SVG element's class.
   * @param attributeOptionId The ID of the MeasurementContainer.
   */
  resetSvgFill(measureName: string, attributeOptionId: number): void {
    const svgContainerId = `svg-container-${attributeOptionId}`;
    const svgContainer = document.getElementById(svgContainerId);

    if (!svgContainer) {
      console.warn(`SVG container with ID ${svgContainerId} not found.`);
      return;
    }

    //const classToUse = measureName.toLowerCase().replace(/\s+/g, '');
    const classToUse = measureName
      .split('(')[0] // get part before parentheses
      .toLowerCase()
      .replace(/[^a-z0-9]/g, ''); // clean for class

    const prefix = `svg-${attributeOptionId}`;
    const svgClass = `${prefix}-${classToUse}`;
    const svgElements = svgContainer.querySelectorAll(`.${svgClass}`);

    if (svgElements.length) {
      svgElements.forEach((el) => {
        this.renderer.setStyle(el, 'stroke-width', '1');
        this.renderer.setStyle(el, 'stroke', '#000000ff');
        this.renderer.setStyle(el, 'opacity', '0.1');
      });
    } else {
      console.warn(
        `SVG elements with class ${svgClass} not found in container ${svgContainerId}.`,
      );
    }
  }

  /**
   * Lifecycle hook called after the view has been checked by Angular.
   * Used to manipulate SVG elements inserted via [innerHTML].
   */
  ngAfterViewChecked(): void {
    this.measurements.forEach((measurementContainer) => {
      measurementContainer.measures.forEach((measurement) => {
        if (!this.processed[measurement.id]) {
          this.processed[measurement.id] = true;

          if (measurement.name) {
            this.selectedMeasure[measurement.id] = measurement.name;
            // this.changeSvgFill(
            //   measurement.name,
            //   '#8cc63f',
            //   measurementContainer.attributeOptionId,
            // );
            // Reset processing flag if needed
            //this.processed[measurement.id] = false;
          }
        }
      });
    });
  }

  /**
   * Handles the selection of a measurement input.
   * Changes the SVG fill color accordingly.
   * @param measure The selected measurement.
   * @param measurementContainer The container of the measurement.
   */
  onMeasureSelected(
    measure: Measurement,
    measurementContainer: MeasurementContainer,
  ): void {
    this.selectedMeasure[measure.id] =
      measure.name + measurementContainer.attributeOptionName;

    this.resetSvgFill(measure.name, measurementContainer.attributeOptionId);
    this.changeSvgFill(
      measure.name,
      '#8cc63f',
      measurementContainer.attributeOptionId,
    );
  }

  /**
   * Checks if a specific measurement is selected.
   * @param measurementId The ID of the measurement.
   * @param measureName The name of the measurement.
   * @returns True if selected, else false.
   */
  isMeasureSelected(measurementId: number, measureName: string): boolean {
    return this.selectedMeasure[measurementId] === measureName;
  }

  /**
   * Updates the measurement value in the measurementValues map.
   * @param measureId The ID of the measurement.
   * @param value The new value as a string.
   */
  updateMeasurementValue(measureId: number, value: string): void {
    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue)) {
      this.measurementValues[measureId] = parsedValue;
    } else {
      this.measurementValues[measureId] = 0; // Or another appropriate default value
    }
  }

  /**
   * Handles input changes on measurement inputs.
   * @param event The input event.
   * @param measure The measurement being modified.
   */
  onInputChange(
    event: Event,
    measure: Measurement,
    measurementContainer: MeasurementContainer,
  ): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;

    this.updateMeasurementValue(measure.id, value);

    // Support both old and new field
    const parentIds =
      measure.inputRuleParentIds ||
      (measure.inputRuleParentId ? [measure.inputRuleParentId] : undefined);

    this.validateInput(
      value,
      measure.inputRule,
      measure.name,
      measure.id.toString(),
      measurementContainer,
      parentIds,
    );

    this.validateAllMeasures();
  }

  /**
   * Validates the input based on the provided rule.
   * @param value The input value as a string.
   * @param rule The validation rule.
   * @param fieldName The name of the field.
   * @param measureId The ID of the measurement as a string.
   * @param parentRuleIds The array of IDs of parent rules.
   */

  validateInput(
    value: string,
    rule: string,
    fieldName: string,
    measureId: string,
    measurementContainer: MeasurementContainer,
    parentRuleIds?: number[],
  ): void {
    const parsedValue = parseFloat(value);
    let isValid = true;
    let errorMessage = '';

    // Check for negative values
    if (parsedValue < 0) {
      isValid = false;
      errorMessage = `${fieldName} cannot be negative.`;
    }

    if (isValid) {
      const rangeMatch = fieldName.match(
        /\((\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)\s*cm\)/,
      );

      if (rangeMatch) {
        const min = parseFloat(rangeMatch[1]);
        const max = parseFloat(rangeMatch[2]);

        if (parsedValue < min || parsedValue > max) {
          isValid = false;
          errorMessage = `${fieldName} should be between ${min} and ${max}.`;
        }
      }
    }

    if (isValid && parentRuleIds && parentRuleIds.length > 0) {
      const validParentIds = parentRuleIds.filter((id) => id && id !== 0);

      if (validParentIds.length > 0) {
        const violatedParents: string[] = [];

        for (const parentRuleId of validParentIds) {
          const globalParentMeasure = this.findParentMeasure(parentRuleId);

          let parentMeasure: Measurement | undefined;

          if (globalParentMeasure) {
            parentMeasure = measurementContainer.measures.find(
              (m) =>
                m.name.trim().toLowerCase() ===
                globalParentMeasure.name.trim().toLowerCase(),
            );
          }

          if (
            parentMeasure &&
            this.measurementValues[parentMeasure.id] !== undefined
          ) {
            const parentValue = this.measurementValues[parentMeasure.id];

            const parentMeasureName =
              parentMeasure.name || `Parent ${parentRuleId}`;

            let currentViolation = false;

            switch (rule) {
              case 'LessThan':
                if (parentValue !== null && parsedValue >= parentValue) {
                  currentViolation = true;
                }
                break;

              case 'GreaterThan':
                if (parentValue !== null && parsedValue <= parentValue) {
                  currentViolation = true;
                }
                break;

              case 'LessThanOrEqual':
                if (parentValue !== null && parsedValue > parentValue) {
                  currentViolation = true;
                }
                break;

              case 'GreaterThanOrEqual':
                if (parentValue !== null && parsedValue < parentValue) {
                  currentViolation = true;
                }
                break;

              case 'Equal':
                if (parentValue !== null && parsedValue !== parentValue) {
                  currentViolation = true;
                }
                break;

              case 'NotEqual':
                if (parentValue !== null && parsedValue === parentValue) {
                  currentViolation = true;
                }
                break;

              case 'None':
              default:
                break;
            }

            if (currentViolation) {
              violatedParents.push(parentMeasureName);
            }
          }
        }

        if (violatedParents.length > 0) {
          isValid = false;

          let ruleText = '';

          switch (rule) {
            case 'LessThan':
              ruleText = 'must be less than';
              break;

            case 'GreaterThan':
              ruleText = 'must be greater than';
              break;

            case 'LessThanOrEqual':
              ruleText = 'must be less than or equal to';
              break;

            case 'GreaterThanOrEqual':
              ruleText = 'must be greater than or equal to';
              break;

            case 'Equal':
              ruleText = 'must be equal to';
              break;

            case 'NotEqual':
              ruleText = 'must not be equal to';
              break;
          }

          if (violatedParents.length === 1) {
            errorMessage = `${fieldName} ${ruleText} ${violatedParents[0]}.`;
          } else {
            const lastParent = violatedParents.pop();
            const otherParents = violatedParents.join(', ');

            errorMessage = `${fieldName} ${ruleText} ${otherParents} and ${lastParent}.`;
          }
        }
      }
    }

    // Save error
    if (!isValid) {
      this.errors[measureId] = errorMessage;
    } else {
      this.errors[measureId] = '';
    }
  }
  /**
   * Finds the parent measurement based on measureId.
   * @param measureId The ID of the measurement.
   * @returns The parent Measurement or null if not found.
   */
  findParentMeasure(measureId: number): Measurement | null {
    for (const measurementContainer of this.measurements) {
      for (const measure of measurementContainer.measures) {
        if (measure.id === measureId) {
          return measure;
        }
      }
    }
    return null;
  }

  public async loadSelectedImagesFromAccessories(): Promise<void> {
    console.log(
      '[loadSelectedImagesFromAccessories] Starting to load and convert images to base64',
    );

    // Iterate through accessories and their attributes
    for (const accessory of this.accessories) {
      for (const attribute of accessory.accessory.attributes) {
        // Only process attributes of type "Select" that have an imageUrl
        if (
          attribute.componentType === 'Select' &&
          attribute.imageUrl &&
          attribute.imageUrl.trim() !== ''
        ) {
          console.log(
            `[loadSelectedImagesFromAccessories] Found Select attribute with imageUrl:`,
            {
              guid: attribute.guid,
              name: attribute.name,
              imageUrl: attribute.imageUrl,
            },
          );

          // Check if this attribute already exists in selectedImages
          const existingIndex = this.selectedImages.findIndex(
            (img) => img.guid === attribute.guid,
          );

          // If not in selectedImages, add it
          if (existingIndex === -1) {
            // Find the selected value to get the valueId
            const selectedValue = attribute.values.find(
              (v) => v.value && v.value !== '',
            );

            this.selectedImages.push({
              guid: attribute.guid,
              attributeId: attribute.attributeId,
              valueId: selectedValue ? selectedValue.id : 0,
              imageUrl: attribute.imageUrl, // Use the parent's imageUrl, not the value's imageUrl
            });

            console.log(
              `[loadSelectedImagesFromAccessories] Added attribute to selectedImages for guid: ${attribute.guid}`,
            );
          } else {
            // Update the imageUrl if it already exists
            this.selectedImages[existingIndex].imageUrl = attribute.imageUrl;
            console.log(
              `[loadSelectedImagesFromAccessories] Updated imageUrl for existing guid: ${attribute.guid}`,
            );
          }
        }
      }
    }

    console.log(
      '[loadSelectedImagesFromAccessories] Total images in selectedImages after loading:',
      this.selectedImages.length,
    );

    // Now convert all imageUrls to base64
    for (let i = 0; i < this.selectedImages.length; i++) {
      const selectedImage = this.selectedImages[i];

      // Convert imageUrl to base64 if it's a URL (not already base64)
      if (
        selectedImage.imageUrl &&
        !selectedImage.imageUrl.startsWith('data:')
      ) {
        try {
          console.log(
            `[loadSelectedImagesFromAccessories] Converting imageUrl to base64 for guid: ${selectedImage.guid}, URL: ${selectedImage.imageUrl}`,
          );
          const base64Image = await this.convertImageToBase64(
            selectedImage.imageUrl,
          );

          // Update the imageUrl in selectedImages array
          this.selectedImages[i].imageUrl = `${base64Image}`;
          console.log(
            `[loadSelectedImagesFromAccessories] Successfully converted image to base64 for guid: ${selectedImage.guid}`,
          );
        } catch (error) {
          console.error(
            `[loadSelectedImagesFromAccessories] Error converting image to base64 for guid ${selectedImage.guid}:`,
            error,
          );
        }
      } else if (selectedImage.imageUrl) {
        console.log(
          `[loadSelectedImagesFromAccessories] Image already in base64 format for guid: ${selectedImage.guid}`,
        );
      } else {
        console.warn(
          `[loadSelectedImagesFromAccessories] No imageUrl found for guid: ${selectedImage.guid}`,
        );
      }
    }

    console.log(
      '[loadSelectedImagesFromAccessories] Finished converting images. Current selectedImages:',
      this.selectedImages,
    );
  }
  /**
   * Retrieves the image URL (now SVG content) for a given attribute based on the selected value.
   * @param attribute The attribute to retrieve the SVG content for.
   * @returns The SVG content as SafeHtml or an empty string if not available.
   */
  getImageUrl(attribute: Attribute): string | null {
    const selectedImage = this.selectedImages.find(
      (img) => img.guid === attribute.guid,
    );
    return selectedImage ? selectedImage.imageUrl || null : null;
  }

  /**
   * Retrieves the display text for the selected value of a given attribute.
   * @param attribute The attribute to retrieve the text for.
   * @returns The display text or an empty string if not available.
   */
  getSelectedValueText(attribute: Attribute): string {
    const valueId = this.selectedValues[attribute.guid];

    const selectedValue = attribute.values.find(
      (v) => v.id === Number(valueId),
    );

    return selectedValue ? selectedValue.value.toString() : '';
  }

  /**
   * Handles image loading errors by setting a fallback SVG or empty SVG.
   * @param attributeGuid The GUID of the attribute whose SVG failed to load.
   */
  handleImageError(attributeGuid: string): void {
    // Set a fallback SVG or empty SVG
    this.svgContent[attributeGuid] = this.sanitizer.bypassSecurityTrustHtml('');
  }

  /**
   * Handles changes to attribute selections.
   * Fetches and updates SVG content accordingly.
   * @param attributeGuid The GUID of the attribute.
   * @param event The change event.
   */
  onAttributeChange(attributeGuid: string, event: Event): void {
    this.attributeModified[attributeGuid] = true;
    const inputElement = event.target as HTMLInputElement;
    let valueId = 0;
    let textInputValue = '';

    if (inputElement.type === 'radio' || inputElement.type === 'select-one') {
      valueId = Number(inputElement.value);
      this.selectedValues[attributeGuid] = valueId;
    } else if (inputElement.type === 'number' || inputElement.type === 'text') {
      textInputValue = inputElement.value;
      this.selectedValues[attributeGuid] = textInputValue;

      // Atualizar o attribute.value também
      const attribute = this.findAttributeByGuid(attributeGuid);
      if (attribute) {
        attribute.value = textInputValue;
      }
    } else {
      this.selectedValues[attributeGuid] = valueId;
    }

    if (inputElement.type === 'checkbox') {
      const valueId = Number(inputElement.value);
      if (inputElement.checked) {
        this.selectedValues[attributeGuid] = valueId;
      } else {
        // Remove the value when unchecked
        delete this.selectedValues[attributeGuid];
      }
    }

    // Update the selected value

    // Find the selected accessory and attribute
    let selectedAccessory: FilledAccessory | undefined;
    let selectedAttribute: Attribute | undefined;

    for (const accessory of this.accessories) {
      for (const attr of accessory.accessory.attributes) {
        if (attr.guid === attributeGuid) {
          selectedAccessory = accessory;
          selectedAttribute = attr;
          break;
        }
      }
      if (selectedAttribute) {
        break;
      }
    }

    if (!selectedAccessory || !selectedAttribute) {
      console.warn(
        `Attribute or accessory not found for GUID: ${attributeGuid}`,
      );
      return;
    }

    // Get the selected value details
    const selectedValue = selectedAttribute.values.find(
      (val) => val.id === valueId,
    );

    // Update visibility based on dependencies
    this.updateVisibility();

    // Prepare to update the AccessoriesData object
    const accessoryId = selectedAccessory.accessory.accessoryId;
    const accessoryName = selectedAccessory.accessory.accessoryName;

    // Check if the accessory already exists in the accessoriesData
    let accessoryInData = this.accessoriesData.accessories.find(
      (acc) => acc.accessoryId === accessoryId,
    );

    if (!accessoryInData) {
      // If not, create a new accessory entry
      accessoryInData = {
        accessoryId: accessoryId,
        accessoryName: accessoryName,
        options: [],
      };
      this.accessoriesData.accessories.push(accessoryInData);
    }

    // Prepare the option object without the image first
    const option: Option = {
      attributeOptionId: selectedAttribute.attributeId,
      attributeOptionName: selectedAttribute.name,
      valueId: selectedValue?.id || 0,
      value: selectedValue?.value.toString() || selectedAttribute.value || '',
      image: '', // We'll set the base64 image later if needed
    };

    // Handle image conversion to base64 if imageUrl exists and is SVG
    this.getSvgContent(selectedAttribute); // Fetch and sanitize SVG content

    // Update or add the option in the accessory
    this.updateOptionInAccessoryData(accessoryInData!, option);

    // Handle images for selectedImages if necessary
    if (selectedAttribute.componentType === 'Select') {
      const imageUrl = selectedValue?.imageUrl || '';
      const existingImageIndex = this.selectedImages.findIndex(
        (img) => img.guid === attributeGuid,
      );

      if (existingImageIndex !== -1) {
        this.selectedImages[existingImageIndex].valueId = valueId;
        this.selectedImages[existingImageIndex].imageUrl = imageUrl;
      } else {
        this.selectedImages.push({
          guid: attributeGuid,
          attributeId: selectedAttribute.attributeId,
          valueId: valueId,
          imageUrl: imageUrl,
        });
      }
    }
  }

  private findAttributeByGuid(guid: string): any {
    for (const accessory of this.accessories) {
      const attribute = accessory.accessory.attributes.find(
        (attr) => attr.guid === guid,
      );
      if (attribute) {
        return attribute;
      }
    }
    return null;
  }

  /**
   * Converts an image URL to a Base64-encoded string.
   * @param url The URL of the image.
   * @returns A promise that resolves to the Base64 string.
   */
  private getImageBase64(url: string): Promise<string> {
    return fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          }),
      );
  }

  /**
   * Updates or adds an option in the accessory data.
   * @param accessoryInData The accessory data to update.
   * @param option The option to add or update.
   */
  private updateOptionInAccessoryData(
    accessoryInData: Accessory,
    option: Option,
  ): void {
    const existingOptionIndex = accessoryInData.options.findIndex(
      (opt) => opt.attributeOptionId === option.attributeOptionId,
    );

    if (existingOptionIndex !== -1) {
      // Update existing option
      accessoryInData.options[existingOptionIndex] = option;
    } else {
      // Add new option
      accessoryInData.options.push(option);
    }
  }

  /**
   * Determines if an attribute should be hidden based on its dependencies.
   * @param attribute The attribute to check.
   * @returns True if the attribute should be hidden, else false.
   */
  isHidden(attribute: Attribute): boolean {
    if (attribute.dependencies && attribute.dependencies.length > 0) {
      // Find the accessory containing this attribute
      const accessory = this.accessories.find((acc) =>
        acc.accessory.attributes.some((attr) => attr.guid === attribute.guid),
      );

      if (!accessory) {
        console.warn(
          `Accessory not found for attribute GUID: ${attribute.guid}`,
        );
        return true; // Hide if accessory not found
      }

      // Evaluate each dependency
      return attribute.dependencies.some((dependency: Dependency) => {
        // Find the parent attribute within the same accessory
        const parentAttribute = accessory.accessory.attributes.find(
          (attr) => attr.attributeId === dependency.attributeId,
        );

        if (!parentAttribute) {
          console.warn(
            `Parent attribute with ID ${dependency.attributeId} not found in accessory ${accessory.accessory.accessoryName}`,
          );
          return true; // Hide if parent attribute not found
        }

        // Get the selected value for the parent attribute
        const selectedValueId = this.selectedValues[parentAttribute.guid];

        // Determine visibility based on the selected value
        return selectedValueId !== dependency.valueId;
      });
    }

    return false; // Show if no dependencies
  }

  /**
   * Updates the visibility of attributes based on their dependencies.
   */
  updateVisibility(): void {
    this.accessories.forEach((accessory) => {
      accessory.accessory.attributes.forEach((attribute) => {
        attribute.isHidden = this.isHidden(attribute);
      });
    });
  }

  /**
   * Tracks attributes by their GUID to optimize rendering.
   * @param index The index of the attribute in the loop.
   * @param attribute The attribute object.
   * @returns The GUID of the attribute.
   */
  trackAttribute(index: number, attribute: Attribute): string {
    return attribute.guid;
  }

  /**
   * Validates the entire form.
   * @returns True if valid, else false.
   */
  isValid(): boolean {
    // Check for errors and ensure all measurements are filled
    const allFilled = this.measurements.every(
      (measurementContainer: MeasurementContainer) => {
        return measurementContainer.measures.every(
          (measurement: Measurement) => {
            if (measurement.disabled) {
              return true;
            }
            const value = this.measurementValues[measurement.id];
            return value !== undefined && value !== null && value >= 0;
          },
        );
      },
    );

    if (allFilled) {
      this.measurements.forEach(
        (measurementContainer: MeasurementContainer) => {
          measurementContainer.measures.forEach((measurement: Measurement) => {
            if (measurement.disabled) {
              this.errors[measurement.id.toString()] = '';
              return;
            }

            const value = this.measurementValues[measurement.id];
            if (
              value === undefined ||
              value === null ||
              value < 0 ||
              isNaN(value)
            ) {
              this.errors[measurement.id.toString()] =
                `${measurement.name} is required.`;
            } else {
              // Support both old and new field
              const parentIds =
                measurement.inputRuleParentIds ||
                (measurement.inputRuleParentId
                  ? [measurement.inputRuleParentId]
                  : undefined);

              this.validateInput(
                value.toString(),
                measurement.inputRule,
                measurement.name,
                measurement.id.toString(),
                measurementContainer,
                parentIds,
              );
            }
          });
        },
      );
    }

    const noErrors = Object.values(this.errors).every((error) => error === '');

    if (!noErrors || !allFilled) {
      this.markAllFieldsAsTouched();
    }

    return noErrors && allFilled;
  }

  /**
   * Validates all measures in the form.
   */
  validateAllMeasures(): void {
    this.measurements.forEach((measurementContainer: MeasurementContainer) => {
      measurementContainer.measures.forEach((measure: Measurement) => {
        if (measure.disabled) {
          this.errors[measure.id.toString()] = '';
          return;
        }

        const value = this.measurementValues[measure.id];
        if (value !== undefined && value !== null) {
          // Support both old and new field
          const parentIds =
            measure.inputRuleParentIds ||
            (measure.inputRuleParentId
              ? [measure.inputRuleParentId]
              : undefined);

          this.validateInput(
            value.toString(),
            measure.inputRule,
            measure.name,
            measure.id.toString(),
            measurementContainer,
            parentIds,
          );
        }
      });
    });
  }

  /**
   * Marks all fields as touched to display validation messages.
   */
  public markAllFieldsAsTouched(): void {
    this.measurements.forEach((measurementContainer: MeasurementContainer) => {
      measurementContainer.measures.forEach((measurement: Measurement) => {
        if (measurement.disabled) {
          // Se estiver desabilitada, não marca como erro
          return;
        }

        const value = this.measurementValues[measurement.id];

        if (
          value === undefined ||
          value === null ||
          value < 0 ||
          isNaN(value)
        ) {
          this.errors[measurement.id.toString()] =
            `${measurement.name} is required.`;
        }
      });
    });

    // Additionally, mark accessory attributes as needed
    this.accessories.forEach((accessory) => {
      accessory.accessory.attributes.forEach((attribute) => {
        if (!attribute.isHidden) {
          const valueId = this.selectedValues[attribute.guid];
          // Verifica se o valor está realmente vazio (não considerando 0 como inválido)
          if (valueId === undefined || valueId === null || valueId === '') {
            this.errors[attribute.guid] = `${attribute.name} is required.`;
          } else {
            this.errors[attribute.guid] = '';
          }
        }
      });
    });
  }

  /**
   * Maps FilledAccessory[] to AccessoriesData.
   * @param filledAccessories Array of FilledAccessory to be mapped.
   * @returns A Promise that resolves to AccessoriesData.
   */
  public async mapFilledAccessoriesToAccessoriesData(
    filledAccessories: FilledAccessory[],
  ): Promise<AccessoriesData> {
    const accessoriesData: AccessoriesData = { accessories: [] };

    // Iterate through each FilledAccessory
    for (const filledAccessory of filledAccessories) {
      const { accessory, selectedAttributes, selectedImage } = filledAccessory;

      // Initialize the AccessoryData object
      const accessoryData: any = {
        accessoryId: accessory.accessoryId,
        accessoryName: accessory.accessoryName,
        options: [],
      };

      // Merge accessory.attributes and selectedAttributes by `guid`
      const mergedAttributesMap: Map<string, Attribute> = new Map();

      // Overwrite or add attributes from selectedAttributes to the map if they have a valid value
      for (const attr of selectedAttributes) {
        if (this.hasValidValue(attr)) {
          mergedAttributesMap.set(attr.guid, { ...attr });
        }
      }

      // Add attributes from accessory.attributes to the map if they have a valid value
      for (const attr of accessory.attributes) {
        if (this.hasValidValue(attr)) {
          mergedAttributesMap.set(attr.guid, { ...attr });
        }
      }

      // Iterate over the merged attributes
      for (const attribute of mergedAttributesMap.values()) {
        // Ensure the `value` is filled
        if (
          attribute.value !== null &&
          attribute.value !== undefined &&
          attribute.value !== ''
        ) {
          var valueIdAux = attribute.values.find(
            (s) => s.value === attribute.value,
          )?.id;

          const option: Option = {
            attributeOptionId: attribute.attributeId,
            attributeOptionName: attribute.name,
            valueId: valueIdAux ?? 0, // Ensure valueIdAux is a number
            value: attribute.value.toString(),
            image: this.getImageUrl(attribute), // Placeholder for image data
          };
          // Add the option to the accessory's options array
          accessoryData.options.push(option);
        }
        // Optionally, handle attributes without a value if needed
        else {
          console.warn(
            `Attribute ${attribute.name} (GUID: ${attribute.guid}) has no value and will be skipped.`,
          );
        }
      }
      // Add the fully constructed accessoryData to accessoriesData
      accessoriesData.accessories.push(accessoryData);
    }

    return accessoriesData;
  }

  /**
   * Checks if an attribute has a non-empty value.
   * @param attr - The attribute to check.
   * @returns True if the attribute's value is non-empty; otherwise, false.
   */
  private hasValidValue(attr: Attribute): boolean {
    return attr.value !== null && attr.value !== undefined && attr.value !== '';
  }

  /**
   * Converts an image URL to a Base64-encoded string.
   * @param url The URL of the image.
   * @returns A Promise that resolves to the Base64 string.
   */
  private convertImageToBase64(url: string): Promise<string> {
    return fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch image from URL: ${url}`);
        }
        return response.blob();
      })
      .then(
        (blob) =>
          new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const result = reader.result as string;
              // Remove the data URL prefix to get only the Base64 string
              const base64 = result.split(',')[1];
              resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          }),
      );
  }

  getEmptySvg(): string {
    return '';
  }

  private labelHead(m: any): string {
    let n = String(m?.name ?? '');
    n = n.replace(/^\s*(?:[-\u2022]\s*)?\d+\s*[\.\)]\s*/, '');
    n = n.split('(')[0];
    return n.trim();
  }

  private firstToken(m: any): string {
    return this.labelHead(m).split(/\s+/)[0].replace(/[^\w]/g, '');
  }

  private isCircumference(m: any): boolean {
    if (m.type) return String(m.type).toLowerCase() === 'circumference';
    if (m.dimension)
      return String(m.dimension).toLowerCase() === 'circumference';

    const head = this.labelHead(m).toLowerCase();
    const token = this.firstToken(m).toLowerCase();

    if (/^c(?!m$)[a-z0-9]+$/i.test(token)) return true;

    if (
      /\b(circ(?:umference)?|girth|wrist|waist|hip|neck|chest|bust|thigh|arm|calf|ankle|head)\b/i.test(
        head,
      )
    ) {
      return true;
    }

    return false;
  }

  circumferenceList(measure: any) {
    return (measure?.measures ?? []).filter((m: any) =>
      this.isCircumference(m),
    );
  }
  lengthList(measure: any) {
    return (measure?.measures ?? []).filter(
      (m: any) => !this.isCircumference(m),
    );
  }
  /**
   * Atualiza as medidas com base nas dependências e nas opções do atributo.
   * - Se a medida possui dependências, ela ficará visível (isHidden = false).
   * - Se todas as dependências forem satisfeitas (ou seja, se para cada dependência existe
   *   um attributeOption com o mesmo attributeOptionId que o dependency.valueId), a medida
   *   será habilitada; caso contrário, ficará desabilitada.
   *
   * @param attributeOptions Coleção de opções do atributo (por exemplo, vinda do backend)
   * @param measures Coleção de medidas a serem atualizadas
   */
  updateMeasuresStatus(attributeOptions: any[], measures: Measurement[]): void {
    measures.forEach((measure) => {
      // Se a medida tem dependências
      if (measure.dependencies && measure.dependencies.length > 0) {
        // Forçamos a visualização da medida (pode ser necessário de acordo com sua lógica)
        measure.isHidden = false;

        // Verifica se **todas** as dependências estão satisfeitas:
        // Ou seja, para cada dependência, existe um option cujo attributeOptionId
        // seja igual ao dependency.valueId
        const allDependenciesSatisfied = measure.dependencies.some(
          (dependency) =>
            attributeOptions.some(
              (option) => option.valueId === dependency.valueId,
            ),
        );

        // Se todas as dependências estão satisfeitas, habilitamos o campo.
        // Caso contrário, o campo ficará desabilitado.
        measure.disabled = !allDependenciesSatisfied;

        if (measure.disabled) {
          measure.isRequired = false;
        }
      } else {
        // Se não há dependências, a medida permanece habilitada (ou conforme sua lógica)
        measure.disabled = false;
      }
    });
  }

  getTabIndex(
    measureIndex: number,
    inputIndex: number,
    type: 'circumference' | 'length',
  ): number {
    // quantos C e L já foram renderizados nos produtos anteriores
    const prevCirc = this.measurements
      .slice(0, measureIndex)
      .reduce((sum, m) => sum + this.circumferenceList(m).length, 0);

    const prevLen = this.measurements
      .slice(0, measureIndex)
      .reduce((sum, m) => sum + this.lengthList(m).length, 0);

    if (type === 'circumference') {
      // Circunferência começa logo depois de todas as circunferências anteriores
      return prevCirc + prevLen + inputIndex + 1;
    } else {
      // Length começa depois de TODAS as circunferências (anteriores + atuais) e todos os length anteriores
      const currentCircCount = this.circumferenceList(
        this.measurements[measureIndex],
      ).length;
      return prevCirc + prevLen + currentCircCount + inputIndex + 1;
    }
  }
}
